PJQ.collections.commitments = PJQ.collections.commitments ? PJQ.collections.commitments : {};
PJQ.models.commitments = PJQ.models.commitments ? PJQ.models.commitments : {};
PJQ.views.commitments = PJQ.views.commitments ? PJQ.views.commitments : {};

PJQ.modules.commitments = {
    routes: [
        {
            route: 'projects/:projectId/commitments',
            name: 'commitments',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments");
            }
        },
        {
            route: 'projects/:projectId/commitments/:commitmentId',
            name: 'commitment',
            callback: function (projectId, commitmentId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments", {
                    commitmentId: parseInt(commitmentId)
                });
            }
        },
        {
            route: 'projects/:projectId/commitments/changeorders',
            name: 'commitmentchangeorders',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments", {
                    view: 'changeorders'
                });
            }
        },
        {
            route: 'projects/:projectId/commitmentchangeorders',
            name: 'commitmentchangeorders',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments", {
                    view: 'changeorders'
                });
            }
        },
        {
            route: 'projects/:projectId/commitmentchangeorders/:changeOrderId',
            name: 'commitmentchangeorder',
            callback: function (projectId, changeOrderId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments", {
                    changeOrderId: parseInt(changeOrderId)
                });
            }
        },
        {
            route: 'projects/:projectId/commitments/invoices',
            name: 'payableinvoices',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments", {
                    view: 'invoices'
                });
            }
        },
        {
            route: 'projects/:projectId/payableinvoices',
            name: 'payableinvoices',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments", {
                    view: 'invoices'
                });
            }
        },
        {
            route: 'projects/:projectId/payableinvoices/:invoiceId',
            name: 'payableinvoice',
            callback: function (projectId, invoiceId, params) {
                if (PJQ.app.session.user == null) {
                    PJQ.app.router.signInNavigate({
                        cacheRoute: true
                    });
                    return;
                }

                let parametersObject = null;
                if (params && _.size(params.trim()) > 0) {
                    parametersObject = PJQ.helpers.urlHelpers.queryStringToObject(params);
                }
                let response = parametersObject ? parametersObject.response : null;

                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments", {
                    invoiceId: parseInt(invoiceId),
                    inviteResponse: response
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.commitments.routes);

PJQ.views.commitments.BaseDataTable = PJQ.views.dataTables.DataTable.extend({
	defaults: {
		language: {
			zeroRecords: "No Results Available"
		},
		isHideSearch: true,
		dom: '<"top"p<"clear">>rt<"bottom"p<"clear">>'
	},
	events: {
		'click .btn-copy-phone': 'copyPhone',
		'click .btn-copy-fax': 'copyPhone',
		'click .btn-copy-cell': 'copyPhone',
		'click .btn-copy-email': 'copyEmail'
	},
	beforeDataTableRender: function () {
		let self = this;
		this.options.rowCallback = function (row, data) {
		};

		this.options.childDataTables = [];

		this.options.contextMenuOptions = {
			actions: this.getContextMenuItems(),
			isHideNoActions: true
		};

		if(this.options.onRowDoubleClick == null){
			this.options.onRowDoubleClick = _.bind(function (row) {
				if (row.data()) {
					this.editRow(row);
				}
			}, this);
		}

		if (this.options.settings) {
			// enable paging for grids that have a setting for it / are not subgrids
			if (this.options.settings.rowsPerPage !== 0 && this.options.view.indexOf('-') === -1)
				this.options.pageLength = this.options.settings.rowsPerPage;
			else
				this.options.pageLength = 2147483646;

			if (this.options.settings.orderBy !== 'sortOrder') {
				if (_.size(this.options.settings.columns) === 0) {
					if (_.size(this.options.settings.columnsDefault) > 0) {
						this.options.settings.orderBy = this.options.settings.columnsDefault[0];
					}
				}
				else if (this.options.settings.columns.indexOf(this.options.settings.orderBy) === -1) {
					this.options.settings.orderBy = this.options.settings.columns[0];
				}
			}
			_.each(this.getColumns(false, this.options.view), _.bind(function (column, index) {
				if (column.columnData === this.options.settings.orderBy) {
					this.options.order = [[index, this.options.settings.orderAscending ? 'asc' : 'desc']];
				}
			}, this));

			let fixedColumnsLeft = 0;
			this.options.colReorder = {
				fixedColumnsLeft: fixedColumnsLeft,
				realtime: false
			};
		}

		this.options.createdRow = _.bind(this.createdRow, this);

		if (typeof this.options.beforeDataTableRender === 'function') {
			this.options.beforeDataTableRender();
		}
	},
	orderByChanged: function () {
	},
	afterDataTableRenderChild: function () {
	},
	getRowChildTable: function (childOpts) {
	},
	getRowChildData: function (row) {
	},
	setRowStyle: function (row, status, isBlacklisted) {
	},
	getContextMenuItems: function () {
	},
	editRow: function (row) {
	},
	statusChanged: function (statuses) {
	},
	getColumns: function () {
	},
	cleanup: function () {
		this.undelegateEvents();
		$(this.el).empty();
	},
	getIsRootView: function () {
		return (this.options.view.indexOf('-') === -1);
	},
	createdRow: function (row, data, dataIndex) {
	}
});
PJQ.views.commitments.ChangeOrderDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Change Orders have been created yet',
            zeroRecords: "No Change Orders matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'data-table-header-change-orders')
        },
        toggleRowClass: '.change-order-toggle-row'
    },
    events: {
        'click .view-commitment': 'viewCommitmentClicked'
    },
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
    },
    getDefaultFilter: function () {
        return _.size(this.options.statusIds) > 0 ? this.options.statusIds : this.options.userSettings.get('defaultStatusFilter');
    },
    afterSearch: function () {
        if (typeof this.options.afterSearch === 'function') {
            this.options.afterSearch();
        }
    },
    afterHeaderRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.change-orders-status-filter'),
            defaultValue: this.getDefaultFilter(),
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.setFilter(PJQ.constants.commitments.changeOrderFilterType.STATUS_FILTER, value);
            }, this)
        });
        this.setFilter(PJQ.constants.commitments.changeOrderFilterType.STATUS_FILTER, this.getDefaultFilter());
    },
    getFilterData: function () {
        let statusFilter = this.getFilter(PJQ.constants.commitments.changeOrderFilterType.STATUS_FILTER);
        if (_.size(statusFilter) === 0) {
            return this.options.data;
        }

        return _.filter(this.options.data, function (row) {
            return (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')));
        });
    },
    getColumns: function (includeAllColumns = false) {
        this.options.canViewCommitments = PJQ.app.session.project.hasPermission('commitments.canView');

        let columns = [],
            includeColumns = ['status', 'commitment', 'contractedContact.companyName', 'number', 'changeReason', 'description', 'contractDate', 'invoicedDate', 'dueDate', 'createdOn', 'amount', 'markupAmount', 'taxAmount', 'grandTotal'];

        if (this.options.customFields) {
            _.each(this.options.customFields.models, _.bind(function (customField) {
                includeColumns.push('fieldValue' + customField.get('fieldNumber'));
            }, this));
        }

        if (!includeAllColumns) {
            if (this.options.settings && _.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings && this.options.settings.columnsDefault ? this.options.settings.columnsDefault : includeColumns;

            columns.push({
                "columnData": "childData",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": (data, type, row) => {
                    if (!this.options.isAdmin) {
                        return "";
                    }

                    let exObj = row.get('externalObject');
                    if (exObj == null) {
                        return '';
                    }

                    return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.commitments.changeOrderStatusNames[row.get('statusId')]
                        }, this)
                    });
                    break;
                case 'commitment':
                    columns.push({
                        "columnData": "commitment",
                        "title": "Commitment",
                        "data": "attributes.commitmentNumber",
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('commitmentNumber');
                            }

                            if (this.options.canViewCommitments) {
                                return '<a class="view-commitment" href="javascript:void(0)" data-id="' + row.get('commitmentId') + '">' + row.get('commitmentNumber') + '</a>';
                            }
                            return data;
                        }, this)
                    },);
                    break;
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('number');
                            }

                            return '<a class="btn-view-change-order" href="javascript:void(0)" data-id="' + row.id + '">' + row.get('number') + '</a>';
                        }, this)
                    });
                    break;
                case 'changeReason':
                    columns.push({
                        "columnData": "changeReason",
                        "data": "attributes.changeReason",
                        "title": "Change Reason"
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"
                    });
                    break;
                case 'contractDate':
                    columns.push({
                        "columnData": "contractDate",
                        "data": "attributes.contractDate",
                        "title": 'Contract Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'invoicedDate':
                    columns.push({
                        "columnData": "invoicedDate",
                        "data": "attributes.invoicedDate",
                        "title": 'Invoiced Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'dueDate':
                    columns.push({
                        "columnData": "dueDate",
                        "data": "attributes.dueDate",
                        "title": 'Due Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'contractedContact.companyName':
                    columns.push({
                        "columnData": "contractedContact.companyName",
                        "title": "Company",
                        "titleSettings": "Contracted Company",
                        "render": _.bind(function (data, type, row) {
                            return row.get('contractedContact') ? row.get('contractedContact').companyName : 'N/A';
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "10%",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
                case 'taxAmount':
                    columns.push({
                        "columnData": "taxAmount",
                        "data": "attributes.taxAmount",
                        "title": "Tax",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'markupAmount':
                    columns.push({
                        "columnData": "markupAmount",
                        "data": "attributes.markupAmount",
                        "title": "Markup",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'grandTotal':
                    columns.push({
                        "columnData": "grandTotal",
                        "data": "attributes.amount",
                        "title": "Grand Total",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                        }, this)
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue')) {
                        _.each(this.options.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true)).toFixed(2);
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? fieldValue.toString() + '%' : '';
                                                }

                                                break;
                                        }

                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover" style="min-width:80px;"><button type="button" class="btn btn-info btn-view-change-order" title="View change order"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                }, this),
                "orderable": false,
                "searchable": false,
                resizable: false,
                "width": "100px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    viewCommitmentClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewCommitment(row.data().get('commitmentId'));
    },
    viewCommitment: function (commitmentId) {
        new PJQ.views.commitments.CommitmentEditModal({
            model: new PJQ.models.commitments.Commitment({
                id: commitmentId
            })
        });
    }
});
PJQ.views.commitments.ChangeOrderEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'modal-change-order-edit'),
        width: '95%',
        maxWidth: 1500,
        model: null,
        fromChangeRequest: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-view-commitment': 'viewCommitment',
        'click .btn-add-line-item': 'addLineItem',
        'click .btn-close': 'close',
        'click .btn-submit': 'submitChangeOrder',
        'click .btn-save-email': 'saveEmail',
        'click .btn-save': 'saveChangeOrder',
        'click .btn-delete': 'deleteChangeOrder',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-export': 'exportChangeOrder',
        'click .btn-email': 'email',
        'click .nav-link': 'activeViewChanged',
        'click .btn-copy-markups': 'copyMarkups',
        'click .btn-view-history': 'viewHistory'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.coreFieldSettings = await this.options.project.fetchCommitmentChangeOrderFieldSettings();
        this.customFields = await this.options.project.fetchCommitmentChangeOrderCustomFields();
        this.settings = await this.options.project.fetchCommitmentChangeOrderSettings();
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();

        if (this.model == null) {
            let customFieldValues = [];
            _.each(this.customFields.models, function (model, index) {
                let value = model.get('defaultValue') ? model.get('defaultValue') : '';
                if (model.get('fieldType') === 'CHOICE') {
                    value = parseInt(value);
                }
                customFieldValues.push({
                    fieldNumber: model.get('fieldNumber'),
                    fieldTypeId: model.get('fieldTypeId'),
                    fieldType: model.get('fieldType'),
                    isMultiple: model.get('isMultiple'),
                    value: value,
                    id: model.get('id')
                })
            }, this);

            this.model = new PJQ.models.commitments.ChangeOrder({
                description: this.options.fromChangeRequest ? this.options.fromChangeRequest.get('description') : '',
                commitmentId: this.options.commitment.id,
                commitmentNumber: this.options.commitment.get('number'),
                contractedContact: this.options.commitment.contractedContact,
                contractedContactId: this.options.commitment.get('contractedContactId'),
                invoiceContact: this.options.commitment.contractedContact,
                invoiceContactId: this.options.commitment.get('invoiceContactId'),
                accountingMethod: this.options.commitment.get('accountingMethod'),
                projectId: this.options.commitment.get('projectId'),
                statusId: PJQ.constants.primeContracts.changeOrderStatus.DRAFT,
                lineItems: this.options.lineItems,
                customFieldValues: customFieldValues
            });
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        if (this.options.commitment == null) {
            this.options.commitment = new PJQ.models.commitments.Commitment({
                id: this.model.get('commitmentId')
            });
        }

        if (!this.options.commitment.isFetched) {
            await this.options.commitment.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canEdit = this.options.project.hasPermission('commitmentChangeOrders.canEdit');
        this.options.canEditLineItems = this.options.canEdit;
        this.options.canViewCommitments = this.options.project.hasPermission('commitments.canView');
        this.options.isAdmin = this.options.project.hasPermission('commitmentChangeOrders.isAdmin');
        this.options.canDelete = this.options.isAdmin;
        this.options.canEditStatus = this.options.isAdmin;

        this.options.disabledStatuses = null;
        let fnGetGreaterStatuses = (statusId) => {
                return _.filter(PJQ.constants.commitments.changeOrderStatus, (st) => {
                    return st < statusId;
                });
            },
            status = this.model.get('statusId');

        let isContractedContact = PJQ.app.session.contact && PJQ.app.session.contact.id === this.model.get('contractedContactId');
        this.options.isSubmitting = isContractedContact && status === PJQ.constants.commitments.changeOrderStatus.DRAFT;

        if (status === PJQ.constants.commitments.changeOrderStatus.DRAFT) {
            this.options.canEdit = isContractedContact || PJQ.app.session.project.hasPermission('commitmentChangeOrders.canEdit');
            this.options.canEditLineItems = this.options.canEdit;
            this.options.canDelete = this.options.isAdmin;
        } else if (status === PJQ.constants.commitments.changeOrderStatus.APPROVED) {
            this.options.canEditLineItems = false;
            this.options.canEdit = PJQ.app.session.project.hasPermission('commitmentChangeOrders.canEdit');
            this.options.canDelete = false;
        } else if (status === PJQ.constants.commitments.changeOrderStatus.VOID) {
            this.options.canEditLineItems = false;
            this.options.canEdit = false;
            this.options.canDelete = true;
        } else {
            this.options.canEdit = PJQ.app.session.project.hasPermission('commitmentChangeOrders.canEdit');
            this.options.canEditLineItems = this.options.canEdit;
            this.options.canDelete = this.options.isAdmin;
        }

        if (_.size(this.model.invoices.models) > 0) {
            this.options.canEditLineItems = false;
        }

        if (this.model.invoices.models.length > 0) {
            this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.commitments.changeOrderStatus.APPROVED);
            this.options.canEditLineItems = false;
            this.options.canDelete = false;
        }

        if (this.erpIntegration != null) {
            let syncStatus = this.model.erpSyncStatus();
            if (syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED
            ) {
                this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.commitments.changeOrderStatus.APPROVED);
                this.options.canEdit = false;
                this.options.canEditLineItems = false;
                this.options.canDelete = false;
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            customFields: this.customFields,
            erpIntegration: this.erpIntegration,
            canEditLineItems: this.options.canEditLineItems,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            isSubmitting: this.options.isSubmitting,
            canViewCommitments: this.options.canViewCommitments,
            isFetched: this.isFetched,
            activeView: this.options.activeView,
            views: this.views,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this),
            unCopiedMarkupsCount: _.size(this.getUnCopiedMarkups())
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.activateView(this.options.activeView);

        this.stopListening(this.model.markupItems);
        this.listenTo(this.model.markupItems, 'update', (markup) => {
            if(markup && markup.get('delete') && (markup.lineItem || markup.get('lineItemId'))){
                let lineItem = markup.lineItem ?? this.model.lineItems.findWhere({appliedMarkupId: markup.id});
                if(lineItem){
                    if(lineItem.get('id') > 0){
                        lineItem.set('delete', true);
                    } else {
                        this.model.lineItems.remove(lineItem);
                    }
                }
            }

            this.updateCounts();
            this.lineItemsView.render();
        });

        this.stopListening(this.model);
        this.listenTo(this.model, 'change:statusId', () => {
            this.renderERP();
        });
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        // we just render everything right away
        // if performance becomes an issue, we can render these when their tabs are activated
        this.renderGeneral();
        this.renderLineItems();
        this.renderMarkups();
        this.updateCounts();
    },
    updateCounts: function () {
        this.$('.count-line-items').text(_.size(_.filter(this.model.lineItems.models, (item) => {
            return !item.get('delete');
        })));
        this.$('.count-markups').text(_.size(_.filter(this.model.markupItems.models, function (item) {
            return !item.get('delete');
        })));
    },
    views: {
        GENERAL: 'CCO_General',
        LINEITEMS: 'CCO_LineItems',
        INVOICES: 'CCO_Invoices',
        PAYMENTS: 'CCO_Payments',
        MARKUPS: 'CCO_Markups'
    },
    activeViewChanged: function (e) {
        let view = e.target.hash ? e.target.hash.replace('#', '') : null;
        this.activateView(view);
    },
    activateView: function (view) {
        switch (view) {
            case this.views.LINEITEMS:
            case this.views.INVOICES:
            case this.views.PAYMENTS:
            case this.views.MARKUPS:
                // do nothing
                break;
            default:
                view = this.views.GENERAL;
                break;
        }
        this.$('.nav-link[href="#' + view + '"]').tab('show');
        this.options.activeView = view;
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        let choices = _.map(PJQ.constants.commitments.changeOrderStatus, (st) => {
            return {
                id: st,
                name: PJQ.constants.commitments.changeOrderStatusNames[st],
                disabled: this.options.disabledStatuses != null && this.options.disabledStatuses.indexOf(st) > -1
            }
        });
        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            choices: choices,
            isIntChoices: true,
            defaultValue: this.model.get('statusId'),
            canEdit: this.options.canEditStatus,
            onChange: (newStatus) => {
                let oldStatus = this.model.get('statusId');
                if (newStatus === oldStatus) {
                    return;
                }

                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.save((success) => {
                        if (success) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Change Order saved successfully'
                            });
                        } else {
                            this.model.set('statusId', oldStatus);
                            this.statusPicker.setValue(oldStatus);
                        }
                    })
                } else {
                    this.render();
                }
            }
        });

        this.contractCompanyPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.contracted-company'),
            selectedContact: this.model.contractedContact,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: false,
            displayContactsBlock: true
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.change-order-due-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('dueDate')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('dueDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.change-order-invoiced-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('invoicedDate')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('invoicedDate', newDate);
            }, this)
        });

        this.reviewerPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.change-order-reviewer'),
            selectedContact: this.model.reviewer,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            shouldHideContacts: true,
            canEdit: this.options.canEdit && this.options.isAdmin,
            displayContactsBlock: true,
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            isSingleChoice: true,
            onChange: _.bind(function (selectedContact) {
                this.model.reviewer = selectedContact;
                this.model.set('reviewerId', selectedContact ? selectedContact.id : null);
            }, this)
        });

        this.receivedFromPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.change-order-received-from'),
            selectedContact: this.model.receivedFrom,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEdit && this.options.isAdmin,
            displayContactsBlock: true,
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            isSingleChoice: true,
            onChange: _.bind(function (selectedContact) {
                this.model.receivedFrom = selectedContact;
                this.model.set('receivedFromId', selectedContact ? selectedContact.id : null);
            }, this)
        });

        if (_.size(this.customFields) > 0) {
            this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.change-order-custom-fields'),
                isEdit: this.options.canEdit,
                isAdmin: this.options.isAdmin,
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                onChange: _.bind(function () {
                    this.model.isDirty = true;
                }, this)
            });
        }

        if (this.checkFieldVisible('attachments')) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.cco-file-uploader'),
                collection: this.model.attachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canView: false,
                useBlob: true,
                canDelete: this.options.canEdit && this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }
    },
    renderLineItems() {
        if(this.lineItemsView){
            this.lineItemsView.remove();
        }

        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.cco-line-items'),
            collection: this.model.lineItems,
            lineItemModel: PJQ.models.commitments.ChangeOrderLineItem,
            canEdit: this.options.isSubmitting || this.options.canEditLineItems,
            canDelete: this.options.isSubmitting || this.options.canEditLineItems,
            accountingMethod: this.model.get('accountingMethod'),
            canChangeAccountingMethod: this.options.canEditLineItems,
            commitmentId: this.model.get('commitmentId'),
            commitment: this.options.commitment,
            showBilling: this.model.get('statusId') === PJQ.constants.commitments.changeOrderStatus.APPROVED,
            financialMarkups: this.model.markupItems,
            enableTax: true,
            showSubTotal: true,
            showGrandTotal: true,
            onAccountingMethodChanged: _.bind(function (value) {
                this.model.set('accountingMethod', value);
            }, this),
            onLineItemChange: _.bind(function () {
                this.model.isDirty = true;
            }, this),
            onLineItemAdd: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this),
            onLineItemDelete: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this)
        });
    },
    viewCommitment: function () {
        this.removeModal();
        new PJQ.views.commitments.CommitmentEditModal({
            model: new PJQ.models.commitments.Commitment({
                id: this.model.get('commitmentId')
            })
        });
    },
    getUnCopiedMarkups: function () {
        if (this.model == null || this.model.markupItems == null
            || this.options.commitment == null || this.options.commitment.markupItems == null) {
            return [];
        }

        return _.filter(this.options.commitment.markupItems.models, (commitmentMarkup) => {
            return !_.some(this.model.markupItems.models, (markup) => {
                return markup.get('percent') === commitmentMarkup.get('percent')
                    && markup.get('name') === commitmentMarkup.get('name')
                    && markup.get('isVertical') === commitmentMarkup.get('isVertical')
                    && markup.get('isCompounding') === commitmentMarkup.get('isCompounding');
            });
        });
    },
    copyMarkups: function () {
        let maxSort = 1;
        if (_.size(this.model.markupItems.models) > 0) {
            maxSort = _.max(this.model.markupItems.models, (markup) => {
                return markup.get('sortOrder');
            });
        }
        _.each(this.getUnCopiedMarkups(), (markup) => {
            let copiedMarkup = new PJQ.financialMarkups.models.FinancialMarkup({
                percent: markup.get('percent'),
                name: markup.get('name'),
                isVertical: markup.get('isVertical'),
                isCompounding: markup.get('isCompounding'),
                costCodeIds: markup.get('costCodeIds'),
                costTypeIds: markup.get('costTypeIds'),
                appliedCostCodeId: markup.get('appliedCostCodeId'),
                appliedCostTypeId: markup.get('appliedCostTypeId'),
                isApplied: markup.get('isApplied'),
                sortOrder: ++maxSort,
                isDirty: true
            });

            this.model.markupItems.add(copiedMarkup);
            if(copiedMarkup.get('appliedCostCodeId') && copiedMarkup.get('appliedCostTypeId')){
                this.model.markupItems.trigger('appliedMarkupChanged', copiedMarkup);
            }
        });
        this.render();
    },
    renderMarkups: function () {
        if (!this.options.isAdmin) {
            return;
        }

        this.markupsView = new PJQ.financialMarkups.views.FinancialMarkupsList({
            el: this.$('.cco-markups'),
            collection: this.model.markupItems,
            canEdit: this.options.canEditLineItems,
            defaultToAppliedMarkups: this.settings.get('defaultToAppliedMarkups'),
        });
    },
    renderERP: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || !this.options.project.isERPSynced()
            || false === this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_COMMITMENTS)) {
            $erp.remove();
            return;
        }

        this.$('.erp-badge').html(PJQ.helpers.erp.getERPBadge(this.model.erpSyncStatus(), this.model.get('externalObject')));

        let canPush = true,
            disablePushReason = "";
        if (_.size(this.model.lineItems.models) === 0 || this.model.get('statusId') !== PJQ.constants.commitments.changeOrderStatus.APPROVED) {
            canPush = false;
            disablePushReason = "Change Order must be approved and have line items";
        }

        if (!this.options.commitment.isERPSynced()) {
            canPush = false;
            disablePushReason = "The commitment for this change order must be synced for this commitment can be pushed";
        }

        PJQ.helpers.erp.renderERPButtons($erp, {
            status: this.model.erpSyncStatus(),
            pushSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COMMITMENT_CHANGE_ORDERS),
            canPush: canPush,
            canPushChanges: false,
            disablePushReason: disablePushReason,
            unlinkSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_COMMITMENT_CHANGE_ORDERS),
        });
    },
    pushERP: function (callback) {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COMMITMENT_CHANGE_ORDERS)) {
            return;
        }

        this.save((success) => {
            if (success) {
                this.erpIntegration.pushCommitmentChangeOrder(this.model, () => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Commitment Change Order pushed to ERP'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    if (callback && typeof callback === 'function') {
                        callback();
                    } else {
                        this.render();
                    }
                });
            }
        });
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.model, () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Commitment Change Order removed from ERP approval'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.render();
            });
        }
    },
    unlinkERP: function () {
        new PJQ.views.modals.YesNo({
            header: "Unlink from ERP",
            body: "Are you sure you want to unlink this Commitment Change Order from your ERP system?",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                this.erpIntegration.unlinkCommitmentChangeOrder(this.model, (success) => {
                    if (success) {
                        loader.remove();
                        PJQ.notifications.notify.successNotify({
                            message: 'Commitment Change Order unlinked from ERP'
                        });

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }

                        this.render();
                    }
                });
            }
        });
    },
    viewHistory: async function () {
        let historyItems = [{
            date: this.model.get('createdOn'),
            person: this.model.get('createdBy'),
            action: 'Change Order Created'
        }];

        let history = new PJQ.collections.commitments.ChangeOrderHistory({}, {
            changeOrderId: this.model.id
        });
        new PJQ.views.history.HistoryTimelineModal({
            collection: history,
            subTitle: 'Commitment Change Order #' + this.model.get('number'),
            items: historyItems
        });
    },
    exportChangeOrder: function () {
        let callback = () => {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'commitmentchangeorders',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ]), {isAPIv2: true});
        };
        if (this.options.canEdit && this.model.hasChanged()) {
            this.save((success) => {
                if (success) {
                    callback();
                }
            });
        } else {
            callback();
        }
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisible');
            }
        }
        return true;
    },
    checkFieldRequired: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isRequired');
            }
        }
        return false;
    },
    saveEmail: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Commitment Change Order saved successfully'
                });

                if (typeof this.options.onSave === 'function')
                    this.options.onSave(this.model);

                this.email();
            }
        });
    },
    savePush: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Commitment Change Order saved successfully'
                });

                if (typeof this.options.onSave === 'function')
                    this.options.onSave(this.model);

                this.pushERP(() => {
                    this.removeModal()
                });
            }
        });
    },
    submitChangeOrder: function () {
        this.model.submit(null, _.bind(function (result) {
            if (result) {
                PJQ.notifications.notify.successNotify({
                    message: 'Change Order submitted successfully'
                });

                if (typeof this.options.onSave === 'function')
                    this.options.onSave(this.model);

                this.removeModal();
            }
        }, this));
    },
    saveChangeOrder: function () {
        let isNew = this.model.isNew();
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Commitment Change Order saved successfully'
                });

                if (typeof this.options.onSave === 'function')
                    this.options.onSave(this.model, isNew);

                this.removeModal();
            }
        });
    },
    validate: function () {
        let isValid = true;

        if (this.customFieldsForm != null && !this.customFieldsForm.validate())
            isValid = false;

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-number'), true);
        if ((!this.model.isNew() || this.checkFieldRequired('number')) && _.size(this.model.get('number')) === 0) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-number'), false);
        }

        if (this.checkFieldRequired('reviewer')) {
            if (!this.reviewerPicker.validate()) {
                isValid = false;
            }
        }

        if (this.checkFieldRequired('receivedFromId')) {
            if (!this.receivedFromPicker.validate()) {
                isValid = false;
            }
        }

        if (this.checkFieldRequired('changeReason')) {
            let $changeReason = this.$('.change-reason');
            PJQ.helpers.inputHelpers.setInputError($changeReason, true);
            if (_.size(this.model.get('changeReason')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($changeReason, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('invoicedDate')) {
            let $invoicedDate = this.$('.change-order-invoiced-date');
            PJQ.helpers.inputHelpers.setInputError($invoicedDate, true);
            if (this.model.get('invoicedDate') == null || this.model.get('invoicedDate').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($invoicedDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('dueDate')) {
            let $dueDate = this.$('.change-order-due-date');
            PJQ.helpers.inputHelpers.setInputError($dueDate, true);
            if (this.model.get('dueDate') == null || this.model.get('dueDate').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($dueDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('description')) {
            let $description = this.$('.change-order-description');
            PJQ.helpers.inputHelpers.setInputError($description, true);
            if (_.size(this.model.get('description')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($description, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('attachments')) {
            this.fileUploader.clearError();
            let hasValidAttachment = _.find(this.model.attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.fileUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (!isValid) {
            this.activateView(this.views.GENERAL);
            return isValid;
        }

        if (!this.lineItemsView.validate()) {
            isValid = false;
            this.activateView(this.views.LINEITEMS);
            return isValid;
        }

        return isValid;
    },
    save: function (callback) {
        if (!this.validate()) {
            this.$('.modal').prevObject.scrollTop(0);
            if (typeof callback === 'function') {
                callback(false);
            }
            return;
        }

        let newMarkupLines = this.model.lineItems.filter(function (lineItem) {
            return lineItem.markup && lineItem.isNew();
        });

        if(_.size(newMarkupLines) > 0) {
            this.model.lineItems.remove(newMarkupLines);
        }

        this.model.save({
            customFields: this.customFieldsForm != null ? this.customFieldsForm.getChanged() : null,
            reviewer: this.reviewer ? this.reviewer.toJSON() : null,
            receivedFrom: this.receivedFrom ? this.receivedFrom.toJSON() : null,
            lineItems: this.model.lineItems.toJSON()
        }, {
            success: () => {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.options.project.trigger('commitmentCOChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            },
            error: (data) => {
                if (typeof callback === 'function') {
                    callback(false);
                }
                PJQ.notifications.notify.errorNotify({
                    message: data.responseJSON.error
                });
            }
        });

        return true;
    },
    deleteChangeOrder: function () {
        let changeOrderId = this.model.id;
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this change order?",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Change order deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(changeOrderId);

                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `A Change Order has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            header: "Email Commitment Change Order",
            project: PJQ.app.session.project,
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Commitment Change Order email sent'
                    });
                }, this));
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveChangeOrder();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});
PJQ.views.commitments.ChangeOrdersList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'commitment-change-orders-list'),
        changeOrderId: null
    },
    events: {
        'click .btn-settings': 'editSettings',
        'click .btn-add-change-order': 'newChangeOrder',
        'click .btn-view-change-order': 'viewChangeOrderClicked',
        'click .btn-delete-change-order': 'deleteChangeOrderClicked',
        'click .btn-export': 'exportChangeOrderList',
        'click .btn-pull-erp': 'pullERP',
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.commitments.ChangeOrders(null, {
                projectId: this.options.project.get('projectId'),
                costCodeId: this.options.costCodeId ? this.options.costCodeId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.userSettings = await PJQ.app.session.fetchCommitmentChangeOrderUserSettings();
        this.customFields = await this.options.project.fetchCommitmentChangeOrderCustomFields();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canAdd = this.options.project.hasPermission('commitmentChangeOrders.canAdd');
        this.options.canViewCommitments = this.options.project.hasPermission('commitments.canView');
        this.options.isAdmin = this.options.project.hasPermission('commitmentChangeOrders.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        PJQ.app.session.project.off('commitmentCOChanged');
        PJQ.app.session.project.on('commitmentCOChanged', function (changeOrder) {
            this.collection.add(changeOrder);
            this.render();
        }, this);

        if (this.options.changeOrderId > 0) {
            let initChangeOrder = this.collection.get(this.options.changeOrderId);
            if (initChangeOrder != null) {
                this.viewChangeOrder(initChangeOrder);
                this.options.changeOrderId = null;
            }
        }
    },
    renderERPButton: function () {
        let $erp = this.$('.erp-sync')
        if (!this.options.isAdmin || this.erpIntegration == null || !this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_COMMITMENTS) || !this.options.project || !this.options.project.isERPSynced()) {
            $erp.remove();
            return;
        }

        let pullSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMMITMENT_CHANGE_ORDERS);
        PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: false,
            pullSupported: pullSupported
        });
    },
    pullERP: function () {
        if (this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMMITMENT_CHANGE_ORDERS)) {
            this.erpIntegration.pullCommitmentChangeOrders(this.options.project, _.bind(function (res) {
                PJQ.notifications.notify.successNotify({
                    message: 'Commitment Change Orders successfully pulled from ERP'
                });

                this.collection.reset(res);
                this.render();
            }, this));
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.commitments.ChangeOrderDataTable({
            el: this.$('.change-orders-data'),
            rowId: "cid",
            data: this.collection.models,
            statusIds: this.options.statusIds,
            isAdmin: this.options.isAdmin,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    canAdd: this.options.canAdd,
                    isAdmin: this.options.isAdmin
                };
            }, this),
            userSettings: this.userSettings,
            canViewCommitments: this.options.canViewCommitments,
            settings: this.userSettings.getSettings(PJQ.constants.commitments.view.CHANGE_ORDERS),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsLeft: 1,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                this.userSettings.save();
            }, this),
            onRowDoubleClick: _.bind(function (row) {
                this.viewChangeOrder(row.data());
            }, this),
            afterDataTableRender: _.bind(function () {
                if (PJQ.app.session.erpIntegration && PJQ.app.session.erpIntegration.id > 0) {
                    this.renderERPButton();
                }
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewChangeOrder(row.data());
                        }, this)
                    }
                ]
            }
        });
    },
    exportChangeOrderList: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'commitmentchangeorders'
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            }
        ]), {isAPIv2: true});
    },
    newChangeOrder: function (e) {
        this.viewChangeOrder();
    },
    viewChangeOrderClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewChangeOrder(row.data());
    },
    viewChangeOrder: function (changeOrder) {
        let isNew = changeOrder == null
        new PJQ.views.commitments.ChangeOrderEditModal({
            model: changeOrder,
            onSave: _.bind(function (changeOrder) {
                if (isNew) {
                    this.collection.add(changeOrder);
                }
                this.renderView();
            }, this),
            onDelete: _.bind(function (changeOrder) {
                this.collection.remove(changeOrder);
                this.renderView();
            }, this)
        });
    },
    deleteChangeOrderClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteChangeOrder(row);
    },
    deleteChangeOrder: function (row) {
        if (row != null) {
            let changeOrder = row.data();
            if (changeOrder != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Change Order",
                    body: "Are you sure you want to delete this Change Order?",
                    onDelete: _.bind(function () {
                        changeOrder.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(changeOrder);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    },
    editSettings: function () {
        new PJQ.views.commitments.ChangeOrderSettingsModal({
            changeOrdersView: this,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    }
});

PJQ.views.commitments.ModalViewChangeOrders = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'modal-view-change-orders'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {},
    beforeModalCreated: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model != null) {
            new PJQ.views.commitments.ChangeOrdersList({
                el: this.$('.modal-body'),
                model: this.model,
                costCodeId: this.model.get('costCodeId'),
                costTypeId: this.model.get('costTypeId'),
                project: this.options.project,
                statusIds: this.options.statusIds
            })
        }
    },
});

PJQ.views.commitments.SelectCommitmentChangeOrdersModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'modal-select-commitment-change-orders'),
        width: '60%',
        maxWidth: 700,
        onSave: _.noop,
        headerSubText: null
    },
    events: {
        "change .select-change-order": "selectChangeOrder",
        "click .btn-save": "save",
        "click .btn-cancel": "cancel"
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.isAdmin = PJQ.app.session.project.hasPermission('commitmentChangeOrders.isAdmin');
        this.selectedChangeOrders = [];

        if (this.collection == null) {
            this.collection = new PJQ.collections.commitments.ChangeOrders(null, {
                projectId: this.options.project.get('projectId')
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            headerSubText: this.options.headerSubText,
            isSingleChoice: this.options.isSingleChoice
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        let data;
        if (_.size(this.options.filterStatuses) > 0) {
            data = _.filter(this.collection.models, (model) => {
                let statusId = model.get('statusId');

                if (_.isArray(this.options.filterStatuses)) {
                    return _.includes(this.options.filterStatuses, statusId);
                } else if (_.isNumber(this.options.filterStatuses)) {
                    return this.options.filterStatuses === statusId;
                }

                return false;

            });
        } else {
            data = this.collection.models;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.cco-table'),
            data: data,
            isHideSearch: true,
            order: [],
            columns: [{
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data) {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="select-change-order"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            },
                {
                    "data": "attributes.number",
                    "title": "Number",
                    "orderable": true
                },
                {
                    "columnData": "attributes.contractedContact.companyName",
                    "title": "Company",
                    "titleSettings": "Contracted Company",
                    "render": _.bind(function (data, type, row) {
                        return row.get('contractedContact') ? row.get('contractedContact').companyName : 'N/A';
                    }, this)
                },
                {
                    "data": "attributes.description",
                    "title": "Description",
                    "orderable": false
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "orderable": false,
                    "className": "text-align-right",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(data);
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    selectChangeOrder: function (e) {
        let target = $(e.currentTarget),
            changeOrder = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-cco').not(target).text('Select').prop('checked', false);
            if (changeOrder.get('isSelected')) {
                changeOrder.set('isSelected', false);
                this.selectedChangeOrder = null;
            } else {
                changeOrder.set('isSelected', true);
                this.selectedChangeOrder = changeOrder;
                this.collection.get(changeOrder.id);
                _.each(this.collection.models, _.bind(function (dtChangeOrder) {
                    if (changeOrder.id !== dtChangeOrder.id)
                        dtChangeOrder.set('isSelected', false);
                }, this));
            }
            this.$('.btn-save').attr('disabled', this.selectedChangeOrder == null);

            if (typeof this.options.onChangeOrderSelected === 'function') {
                this.options.onChangeOrderSelected(this.selectedChangeOrder);
            }
        } else {
            if (changeOrder.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                changeOrder.set('isSelected', false);
                this.selectedChangeOrders = _.reject(this.selectedChangeOrders, function (selChangeOrder) {
                    return selChangeOrder.id === changeOrder.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                changeOrder.set('isSelected', true);
                this.selectedChangeOrders.push(changeOrder);
            }
            this.$('.btn-save').attr('disabled', this.selectedChangeOrders == null);

            if (typeof this.options.onChangeOrderSelected === 'function') {
                this.options.onChangeOrderSelected(this.selectedChangeOrders);
            }
        }
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    save: function () {
        if (this.options.onSave) {
            this.options.onSave(this.selectedChangeOrder ? this.selectedChangeOrder : this.selectedChangeOrders);
            this.removeModal();
        }
    }
});
//Models
PJQ.models.commitments.ChangeOrder = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        arr.push({
            endpoint: 'commitmentchangeorders',
            value: this.id
        });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.commitment) {
            this.commitment = model.commitment;
        }

        this.lineItems = new PJQ.collections.commitments.ChangeOrderLineItems(model.lineItems);
        this.attachments = new PJQ.collections.commitments.ChangeOrderAttachments(model.attachments);
        this.invoices = new PJQ.collections.invoicing.PayableInvoices(model.invoices);

        this.markupItems = new PJQ.financialMarkups.collections.FinancialMarkups(model ? model.markupItems : null);

        if (model && model.contractedContact) {
            if (model.contractedContact instanceof PJQ.models.BaseModel) {
                this.contractedContact = model.contractedContact;
            } else {
                this.contractedContact = new PJQ.models.contacts.Contact(model.contractedContact);
            }
        }

        if (model && model.reviewer) {
            if (model.reviewer instanceof PJQ.models.BaseModel) {
                this.reviewer = model.reviewer;
            } else {
                this.reviewer = new PJQ.models.contacts.Contact(model.reviewer);
            }
        }

        if (model && model.receivedFrom) {
            if (model.receivedFrom instanceof PJQ.models.BaseModel) {
                this.receivedFrom = model.receivedFrom;
            } else {
                this.receivedFrom = new PJQ.models.contacts.Contact(model.receivedFrom);
            }
        }

        return model;
    },
    beforeSave: function () {
        let newMarkupLines = this.lineItems.filter(function (lineItem) {
            return lineItem.markup && lineItem.isNew();
        });
        this.lineItems.remove(newMarkupLines);

        this.set({
            lineItems: this.lineItems.toJSON(),
            attachments: this.attachments.toJSON(),
            markupItems: this.markupItems.toJSON()
        });
    },
    submit: function (signature, callback) {
        this.beforeSave();
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/submit',
            isAPIv2: true,
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            if (typeof callback === 'function') {
                this.set(this.parse(response));
                callback(true);
            }
        }, this)).fail(_.bind(function (response) {
            if (typeof callback === 'function') {
                callback(false);
            }
        }, this));
    },
    syncERP: function (callback) {
        return PJQ.models.commitments.Commitment.prototype.syncERP.call(this, callback);
    },
    unlinkERP: function (callback) {
        return PJQ.models.commitments.Commitment.prototype.unlinkERP.call(this, callback);
    },
    makeERPUrl: function (integration) {
        return PJQ.models.commitments.Commitment.prototype.makeERPUrl.call(this, integration);
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    getSubTotal: function () {
        return this.get('amount') + this.get('markupAmount');
    },
    getGrandTotal: function () {
        return this.getSubTotal() + this.get('taxAmount');
    }
});

PJQ.models.commitments.ChangeOrderHistoryItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    actionNames: {
        'status': 'Status Changed',
        'submit': 'Submitted',
        'email': 'Email Sent'
    },
    getActionName: function () {
        return this.actionNames[this.get('action')] ?? this.get('action');
    },
    getDescription: function () {
        switch (this.get('action')) {
            case 'status':
                let fromStatus = this.get('data').from,
                    toStatus = this.get('data').to;
                if (fromStatus == null || toStatus == null) {
                    return '';
                }

                return '' + PJQ.constants.commitments.changeOrderStatusNames[fromStatus] + '<i class="fal fa-arrow-right ml-1 mr-1 fs-14"></i>' + PJQ.constants.commitments.changeOrderStatusNames[toStatus];
            case 'email':
                let to = this.get('data').to;
                if (_.size(to) === 0) {
                    return '';
                }

                return 'To: ' + to.join(', ');
            default:
                return '';
        }
    }
});

PJQ.models.commitments.ChangeOrderLineItem = PJQ.models.budget.BaseLineItem.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.commitments.ChangeOrderAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.commitments.ChangeOrderCustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitmentchangeorders'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.commitments.ChangeOrderSettings = PJQ.models.budget.Settings.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'commitmentchangeorders'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitmentchangeorders'
            },
            {
                endpoint: 'settings'
            }
        ]);
    }
});

PJQ.models.commitments.ChangeOrderUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitmentchangeorders'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.commitments.ChangeOrderFieldSetting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: this.id ? this.id : 'commitmentchangeorders'
            }
        ]);
    }
});

//Collections
PJQ.collections.commitments.ChangeOrders = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.ChangeOrder,
    endpoint: function () {
        let params = [];
        if (this.options.costCodeId && this.options.costTypeId) {
            params.push({
                parameter: 'costCodeId',
                value: this.options.costCodeId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'commitmentchangeorders'
            }
        ], params);
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        _.each(PJQ.constants.commitments.changeOrderStatusBuckets, function (bucket) {
            let total = 0;
            _.each(this.models, function (changeOrder) {
                if (bucket.statuses.indexOf(changeOrder.get('statusId')) !== -1) {
                    total += changeOrder.get('totalAmount');
                }
            });
            result[bucket.name] = total;
        }, this);
        return result;
    }
});

PJQ.collections.commitments.ChangeOrderHistory = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.ChangeOrderHistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitmentchangeorders',
                value: this.options.changeOrderId
            },
            {
                endpoint: 'history'
            }
        ]);
    }
});

PJQ.collections.commitments.ChangeOrderLineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.ChangeOrderLineItem,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitmentchangeorders',
                value: this.options.changeOrderId
            },
            {
                endpoint: 'lineitems'
            }
        ], params);
    }
});

PJQ.collections.commitments.ChangeOrderAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.ChangeOrderAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitmentchangeorders',
                value: this.options.changeOrderId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.commitments.ChangeOrderCustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.ChangeOrderCustomField,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'commitmentchangeorders'
                },
                {
                    endpoint: 'customfields'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitmentchangeorders'
            },
            {
                endpoint: 'customfields'
            }
        ]);
    }
});

PJQ.collections.commitments.ChangeOrderFieldSettings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.ChangeOrderFieldSetting,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'settings'
                },
                {
                    endpoint: 'fields',
                    value: 'commitmentchangeorders'
                }
            ]);

        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: 'commitmentchangeorders'
            }
        ]);
    }
});

PJQ.views.commitments.ChangeOrderSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'modal-commitment-change-order-settings'),
        minWidth: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click .btn-edit-company-default': 'editCompanySettings',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        this.userSettings = this.options.changeOrdersView.userSettings;
    },
    beforeRender: function () {
        // copy userSettings for our UI; we only update global userSettings object on save.
        this.options.userSettings = [];

        this.options.defaultStatusFilter = this.userSettings.get('defaultStatusFilter');
        _.each(this.userSettings.attributes.viewSettings, _.bind(function (setting) {
            let columns = this.options.changeOrdersView.dataTable.getColumns(true),
                selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.userSettings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });
        }, this));
    },
    renderData: function () {
        return {
            userSettings: this.userSettings
        }
    },
    afterRender: function () {
        this.defaultFilterSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-filter-default'),
            isIntChoices: true,
            isMultiple: true,
            defaultValue: this.userSettings.get('defaultStatusFilter'),
            onChange: _.bind(function (value) {
                this.options.defaultStatusFilter = value
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)
        });

        this.selectView(PJQ.constants.commitments.view.CHANGE_ORDERS);
    },
    editCompanySettings: function () {
        this.userSettings = new PJQ.models.commitments.ChangeOrderUserSettings(null, {
            forCompany: true
        });
        this.userSettings.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.userSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        if (view.indexOf('-') === -1) {
            this.rowsPerPage.setValue(this.currentView.rowsPerPage);
            this.$('div.rows-per-page').show();
        }
        else
            this.$('div.rows-per-page').hide();

        if (this.dataTable) {
            this.dataTable.undelegateEvents();
            $(this.dataTable.el).empty();
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('div.select-columns-datatable'),
            data: this.currentView.columns,
            isHideSearch: true,
            pageLength: 6,
            order: [],
            columns: [
                {"data": "title", "title": "Column", "orderable": false},
                {
                    "data": "visible",
                    "title": "Show",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data) {
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '10%'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });

    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        let fnOnSave = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();
            this.removeModal();
        }, this);

        this.userSettings.set('defaultStatusFilter', this.options.defaultStatusFilter);

        _.each(this.options.userSettings, _.bind(function (settingTemp) {
            _.each(this.userSettings.get('viewSettings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        }
                        else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        this.userSettings.save(null, {
            success: _.bind(function () {
                fnOnSave();
            }, this)
        });
    },
});
PJQ.views.commitments.CommitmentDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Commitments have been created yet',
            zeroRecords: "No Commitments matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'data-table-header-commitments')
        },
        toggleRowClass: '.commitment-toggle-row'
    },
    events: {
        'click .view-commitment': 'viewCommitmentClicked',
    },
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
    },
    getDefaultFilter: function () {
        let defaultFilter = {};
        defaultFilter[PJQ.constants.commitments.filterType.TYPE_FILTER] = this.options.userSettings.get('defaultCommitmentTypeFilter');
        defaultFilter[PJQ.constants.commitments.filterType.TYPE_FILTER] = _.map(defaultFilter[PJQ.constants.commitments.filterType.TYPE_FILTER], function (type) {
            return type * -1;
        });
        defaultFilter[PJQ.constants.commitments.filterType.STATUS_FILTER] = _.size(this.options.statusIds) > 0 ? this.options.statusIds : this.options.userSettings.get('defaultCommitmentStatusFilter');
        return defaultFilter;
    },
    afterSearch: function () {
        if (typeof this.options.afterSearch === 'function') {
            this.options.afterSearch();
        }
    },
    afterHeaderRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.commitments-filter'),
            defaultValue: this.getDefaultFilter(),
            isGrouped: true,
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                _.each(value, _.bind(function (value, filter) {
                    if (filter === PJQ.constants.commitments.filterType.TYPE_FILTER) {
                        value = _.map(value, function (type) {
                            return type * -1;
                        });
                    }
                    this.setFilter(filter, value);
                }, this));
            }, this)
        });
        _.each(this.getDefaultFilter(), function (value, filter) {
            if (filter === PJQ.constants.commitments.filterType.TYPE_FILTER) {
                value = _.map(value, function (type) {
                    return type * -1;
                });
            }
            this.setFilter(filter, value);
        }, this)
    },
    getFilterData: function () {
        let typeFilter = this.getFilter(PJQ.constants.commitments.filterType.TYPE_FILTER),
            statusFilter = this.getFilter(PJQ.constants.commitments.filterType.STATUS_FILTER);
        if (_.size(typeFilter) === 0 && _.size(statusFilter) === 0) {
            return this.options.data;
        }

        return _.filter(this.options.data, function (row) {
            return (_.size(typeFilter) === 0 || _.contains(typeFilter, row.get('commitmentType'))) && (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')));
        });
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['createdOn', 'commitmentType', 'number', 'title', 'description', 'commitmentStatus', 'deliveryDate', 'startDate', 'estimatedCompletionDate', 'actualCompletionDate', 'contractDate', 'signedContractReceivedDate', 'executionDate', 'issuedOnDate', 'returnedDate', 'letterOfIntentDate', 'approvalLetterDate', 'paymentTerms', 'shipVia', 'inclusions', 'exclusions', 'contractedContact.companyName', 'status', 'amount', 'markupAmount', 'taxAmount', 'defaultWorkRetainage', 'defaultMaterialRetainage', 'currentRetainage', 'grandTotal', 'approvedChanges', 'contractTotal', 'progressAmount', 'amountRemaining'];
        if (this.options.customFields) {
            _.each(this.options.customFields.models, _.bind(function (customField) {
                includeColumns.push('fieldValue' + customField.get('fieldNumber'));
            }, this));
        }

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            columns.push({
                "columnData": "erpObject",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": (data, type, row) => {
                    if (!this.options.isAdmin) {
                        return "";
                    }

                    let exObj = row.get('externalObject');
                    if (exObj == null) {
                        return '';
                    }

                    return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.commitments.commitmentStatusNames[row.get('statusId')]
                        }, this)
                    });
                    break;
                case 'commitmentType':
                    columns.push({
                        "columnData": "commitmentType",
                        "data": "attributes.commitmentType",
                        "title": "Type",
                        "width": "110px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.commitments.commitmentTypeNames[row.get('commitmentType')]
                        }, this)
                    });
                    break;
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('number');
                            }

                            return '<a class="btn-view-commitment" href="javascript:void(0)" data-id="' + row.id + '">' + row.get('number') + '</a>';
                        }, this)
                    });
                    break;
                case 'title':
                    columns.push({
                        "columnData": "title",
                        "data": "attributes.title",
                        "title": "Title"
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"
                    });
                    break;
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'deliveryDate':
                    columns.push({
                        "columnData": "deliveryDate",
                        "data": "attributes.deliveryDate",
                        "title": 'Delivery',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'startDate':
                    columns.push({
                        "columnData": "startDate",
                        "data": "attributes.startDate",
                        "title": 'Start',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'estimatedCompletionDate':
                    columns.push({
                        "columnData": "estimatedCompletionDate",
                        "data": "attributes.estimatedCompletionDate",
                        "title": 'Est. Complete',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'actualCompletionDate':
                    columns.push({
                        "columnData": "actualCompletionDate",
                        "data": "attributes.actualCompletionDate",
                        "title": 'Act. Complete',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'contractDate':
                    columns.push({
                        "columnData": "contractDate",
                        "data": "attributes.contractDate",
                        "title": 'Contract Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'signedContractReceivedDate':
                    columns.push({
                        "columnData": "signedContractReceivedDate",
                        "data": "attributes.signedContractReceivedDate",
                        "title": 'Signed Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'executionDate':
                    columns.push({
                        "columnData": "executionDate",
                        "data": "attributes.executionDate",
                        "title": 'Execution Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'issuedOnDate':
                    columns.push({
                        "columnData": "issuedOnDate",
                        "data": "attributes.issuedOnDate",
                        "title": 'Issued On',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'returnedDate':
                    columns.push({
                        "columnData": "returnedDate",
                        "data": "attributes.returnedDate",
                        "title": 'Returned On',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'letterOfIntentDate':
                    columns.push({
                        "columnData": "letterOfIntentDate",
                        "data": "attributes.letterOfIntentDate",
                        "title": 'Letter of Intent',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'approvalLetterDate':
                    columns.push({
                        "columnData": "approvalLetterDate",
                        "data": "attributes.approvalLetterDate",
                        "title": 'Approval Letter',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'paymentTerms':
                    columns.push({
                        "columnData": "paymentTerms",
                        "data": "attributes.paymentTerms",
                        "title": "Payment Terms"
                    });
                    break;
                case 'shipVia':
                    columns.push({
                        "columnData": "shipVia",
                        "data": "attributes.shipVia",
                        "title": "Shipping Info"
                    });
                    break;
                case 'inclusions':
                    columns.push({
                        "columnData": "inclusions",
                        "data": "attributes.inclusions",
                        "title": "Inclusions"
                    });
                    break;
                case 'exclusions':
                    columns.push({
                        "columnData": "exclusions",
                        "data": "attributes.exclusions",
                        "title": "Exclusions"
                    });
                    break;
                case 'contractedContact.companyName':
                    columns.push({
                        "columnData": "contractedContact.companyName",
                        "title": "Company",
                        "titleSettings": "Contracted Company",
                        "render": _.bind(function (data, type, row) {
                            return row.get('contractedContact') ? row.get('contractedContact').companyName : 'N/A';
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "150px",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
                case 'taxAmount':
                    columns.push({
                        "columnData": "taxAmount",
                        "data": "attributes.taxAmount",
                        "title": "Tax",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'markupAmount':
                    columns.push({
                        "columnData": "markupAmount",
                        "data": "attributes.markupAmount",
                        "title": "Markup",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'defaultWorkRetainage':
                    columns.push({
                        "columnData": "defaultWorkRetainagePercent",
                        "data": "attributes.defaultWorkRetainagePercent",
                        "width": "150px",
                        "title": "Default Work Retainage",
                        "className": "text-align-right",
                        "render": (data, type, row) => {
                            return PJQ.helpers.formatHelpers.formatPercent(row.get('defaultWorkRetainagePercent') ?? 0);
                        }
                    });
                    break;
                case 'defaultMaterialRetainage':
                    columns.push({
                        "columnData": "defaultMaterialRetainagePercent",
                        "data": "attributes.defaultMaterialRetainagePercent",
                        "width": "150px",
                        "title": "Default Material Retainage",
                        "className": "text-align-right",
                        "render": (data, type, row) => {
                            return PJQ.helpers.formatHelpers.formatPercent(row.get('defaultMaterialRetainagePercent') ?? 0);
                        }
                    });
                    break;
                case 'currentRetainage':
                    columns.push({
                        "columnData": "currentRetainage",
                        "data": "attributes.retainageAmount",
                        "width": "150px",
                        "title": "Current Retainage",
                        "className": "text-align-right",
                        "render": (data, type, row) => {
                            let retainage = (row.get('retainageAmount') ?? 0) - (row.get('retainageReleasedAmount') ?? 0);
                            if (type === 'sort' || type === 'type') {
                                return retainage;
                            }
                            return PJQ.helpers.formatHelpers.formatCurrency(retainage);
                        }
                    });
                    break;
                case 'grandTotal':
                    columns.push({
                        "columnData": "grandTotal",
                        "data": "attributes.amount",
                        "title": "Grand Total",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                        }, this)
                    });
                    break;
                case 'approvedChanges':
                    columns.push({
                        "columnData": "approvedChanges",
                        "data": "attributes.approvedChanges",
                        "width": "150px",
                        "title": "Approved Changes",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('approvedChanges'));
                        }, this)
                    });
                    break;
                case 'contractTotal':
                    columns.push({
                        "columnData": "contractTotal",
                        "data": "attributes.amount",
                        "width": "150px",
                        "title": "Contract Total",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount') + row.get('approvedChanges'));
                        }, this)
                    });
                    break;
                case 'progressAmount':
                    columns.push({
                        "columnData": "progressAmount",
                        "data": "attributes.progressAmount",
                        "width": "150px",
                        "title": "Billed to Date",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('progressAmount'));
                        }, this)
                    });
                    break;
                case 'amountRemaining':
                    columns.push({
                        "columnData": "amountRemaining",
                        "data": "attributes.amountRemaining",
                        "width": "150px",
                        "title": "Amount Remaining",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount') + row.get('approvedChanges') - row.get('progressAmount'));
                        }, this)
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue')) {
                        _.each(this.options.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "className": [PJQ.constants.commitments.customFieldType.INTEGER, PJQ.constants.commitments.customFieldType.MONEY, PJQ.constants.commitments.customFieldType.PERCENT].indexOf(customField.get('fieldTypeId')) !== -1 ? "text-align-right" : "",
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (!fieldValue)
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)), 2, false) + '%' : '';
                                                }
                                                break;
                                        }

                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover" style="min-width:80px;"><button type="button" class="btn btn-info btn-view-commitment ml-1" title="View commitment"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "100px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    getRowChildTable: function (childOpts) {
        childOpts.costTypes = this.options.costTypes;
        childOpts.unitsOfMeasure = this.options.unitsOfMeasure;
        childOpts.groups = this.options.groups;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.commitments.LineItemDataTable(childOpts);
    },
    getRowChildData: function (row) {
        return new PJQ.collections.commitments.CommitmentLineItems(null, {
            commitmentId: row.data().id
        });
    }
});

PJQ.views.commitments.LineItemDataTable = PJQ.views.commitments.BaseDataTable.extend({
    defaults: {
        language: {
            zeroRecords: "No Line Items Added"
        },
        canEdit: false,
        onEditLineItem: _.noop,
        onDeleteLineItem: _.noop
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns;
        if (this.options.parentData && this.options.parentData.get('accountingMethod') === PJQ.constants.budget.accountingMethod.AMOUNT)
            includeColumns = ['group', 'costTypeDescription', 'description', 'amount', 'billedToDate', 'amountRemaining'];
        else
            includeColumns = ['group', 'costTypeDescription', 'description', 'quantity', 'unitOfMeasure', 'unitPrice', 'amount', 'billedToDate', 'amountRemaining'];

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"

                    });
                    break;
                case 'quantity':
                    columns.push({
                        "columnData": "quantity",
                        "data": "attributes.quantity",
                        "width": "8%",
                        "title": "Units",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatDecimal(row.get('quantity'), 2);
                        }, this)
                    });
                    break;
                case 'unitOfMeasure':
                    columns.push({
                        "columnData": "unitOfMeasure",
                        "data": "attributes.unitId",
                        "orderable": (!this.options.canEdit),
                        "title": "Unit",
                        "width": "5%",
                        "render": _.bind(function (data, type, row) {
                            let unitOfMeasure = this.options.unitsOfMeasure.get(row.get('unitId'));
                            return unitOfMeasure ? unitOfMeasure.get('code') : '';
                        }, this)
                    });
                    break;
                case 'unitPrice':
                    columns.push({
                        "columnData": "unitPrice",
                        "data": "attributes.unitPrice",
                        "width": "10%",
                        "title": "Unit Price",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('unitPrice'));
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "10%",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
                case 'billedToDate':
                    columns.push({
                        "columnData": "billedToDate",
                        "data": "attributes.billedToDate",
                        "width": "10%",
                        "title": "Billed",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('billedToDate'));
                        }, this)
                    });
                    break;
                case 'amountRemaining':
                    columns.push({
                        "columnData": "amountRemaining",
                        "data": "attributes.amountRemaining",
                        "width": "10%",
                        "title": "Amount Remaining",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount') - row.get('billedToDate'));
                        }, this)
                    });
                    break;
                case 'group':
                    columns.push({
                        "columnData": "group",
                        "title": "Cost Code",
                        "render": _.bind(function (data, type, row) {
                            let group = this.options.groups.get(row.get('groupId'));
                            return group ? group.get('groupName') : '';
                        }, this)
                    });
                    break;
                case 'costType':
                    columns.push({
                        "columnData": "costType",
                        "title": "Type Code",
                        "titleSettings": "Cost Type",
                        "width": "8%",
                        "render": _.bind(function (data, type, row) {
                            let costType = this.options.costTypes.get(row.get('costTypeId'));
                            return costType ? costType.get('code') : '';
                        }, this)
                    });
                    break;
                case 'costTypeDescription':
                    columns.push({
                        "columnData": "costTypeDescription",
                        "title": "Type",
                        "render": _.bind(function (data, type, row) {
                            let costType = this.options.costTypes.get(row.get('costTypeId'));
                            return costType ? costType.get('name') : '';
                        }, this)
                    });
                    break;
            }
        }, this));

        if (!includeAllColumns && this.options.canEdit) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {

                    let html = '<div class="show-on-row-hover">';
                    html += '<button type="button" class="btn btn-info edit-line-item ml-1" title="View Line Item"><i class="fal fa-arrow-alt-from-left"></i></button>';

                    if (PJQ.app.session.project.hasPermission('commitments.canEdit'))
                        html += '<button type="button" class="btn btn-danger delete-line-item ml-1" title="Delete Line Item"><i class="fal fa-trash"></i></button>';

                    html += '</div>';

                    return html;
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    }
});

PJQ.views.commitments.CommitmentEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'modal-commitment-edit'),
        width: '95%',
        maxWidth: 1500,
        model: null,
        fromChangeRequest: null,
        commitmentType: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .copy-to-billto': 'copyToHelper',
        'click .copy-to-shipto': 'copyToHelper',
        'click .btn-new-change-order': 'newChangeOrder',
        'click .btn-view-change-order': 'viewChangeOrderClicked',
        'click .btn-new-invoice': 'newInvoice',
        'click .btn-view-invoice': 'viewInvoiceClicked',
        'click .btn-delete': 'deleteCommitment',
        'click .btn-close': 'close',
        'change .input-coi-required': 'renderCOIApproval',
        'change .input-w9-required': 'renderW9Approval',
        'change .input-lien-waiver-required': 'renderLienWaiverApproval',
        'click .btn-save-email': 'saveEmail',
        'click .btn-save': 'saveCommitment',
        'click .btn-submit-for-review': 'submitForReview',
        'click .btn-sign-submit': 'signAndSubmit',
        'click .btn-release-erp-retainage': 'releaseERPRetainage',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-export': 'exportCommitment',
        'click .btn-email': 'email',
        'keydown .input-percent': 'numbersOnly',
        'change .input-percent': 'formatPercent',
        'click .nav-link': 'activeViewChanged',
        'click .btn-view-payment': 'viewPaymentClicked',
        'click .btn-view-history': 'viewHistory'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.coreFieldSettings = await this.options.project.fetchCommitmentFieldSettings();
        this.terms = await this.options.project.fetchCommitmentTerms();
        this.customFields = await this.options.project.fetchCommitmentCustomFields();
        this.settings = await this.options.project.fetchCommitmentSettings();

        this.invoiceSettings = null;
        if (this.options.project.hasPermission('payableInvoices.canView')) {
            this.invoiceSettings = await this.options.project.fetchPayableInvoiceSettings();
        }

        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        this.uploadCustomFields = _.filter(this.customFields.models, function (model) {
            return model.get('fieldTypeId') === 13;
        }, this);

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        if (this.model == null) {
            let customFieldValues = [];
            _.each(this.customFields.models, function (model, index) {
                let value = model.get('defaultValue') ? model.get('defaultValue') : '';
                if (model.get('fieldType') === 'CHOICE') {
                    value = parseInt(value);
                }
                customFieldValues.push({
                    fieldNumber: model.get('fieldNumber'),
                    fieldTypeId: model.get('fieldTypeId'),
                    fieldType: model.get('fieldType'),
                    isMultiple: model.get('isMultiple'),
                    value: value,
                    id: model.get('id')
                })
            }, this);

            this.model = new PJQ.models.commitments.Commitment({
                accountingMethod: this.settings.get('defaultAccountingMethod'),
                contractedContact: this.options.contractedContact ?? null,
                commitmentType: this.options.commitmentType ? this.options.commitmentType : PJQ.constants.commitments.commitmentType.PURCHASE_ORDER,
                title: this.options.fromChangeRequest ? this.options.fromChangeRequest.get('title') : '',
                description: this.options.fromChangeRequest ? this.options.fromChangeRequest.get('description') : '',
                projectId: PJQ.app.session.project.id,
                statusId: PJQ.constants.commitments.commitmentStatus.DRAFT,
                billTo: {},
                shipTo: {},
                lineItems: this.options.lineItems,
                customFieldValues: customFieldValues
            });
        }

        if (this.model.isNew()) {
            this.model.set({
                defaultWorkRetainagePercent: this.settings.get('defaultWorkRetainagePercent'),
                defaultMaterialRetainagePercent: this.settings.get('defaultMaterialRetainagePercent'),
            })
        }

        if (!this.model.isNew() && this.options.fetch !== false) {
            await this.model.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.hasEditPermission = this.options.project.hasPermission('commitments.canEdit');
        this.options.canEdit = this.options.hasEditPermission;
        this.options.canEditInvoiceContact = this.options.hasEditPermission;
        this.options.canEditDates = this.options.hasEditPermission;
        this.options.canUploadAttachments = this.options.canEdit;
        this.options.canEditLineItems = this.options.project.hasPermission('commitments.canEditLineItems');
        this.options.canViewChangeOrders = this.options.project.hasPermission('commitmentChangeOrders.canView');
        this.options.canAddChangeOrders = this.options.project.hasPermission('commitmentChangeOrders.canAdd');
        this.options.canViewInvoices = this.options.project.hasPermission('payableInvoices.canView');
        this.options.canAddInvoices = this.options.project.hasPermission('payableInvoices.canAdd');
        this.options.isAdmin = this.options.project.hasPermission('commitments.isAdmin');
        this.options.canDelete = this.options.isAdmin;
        this.options.canEditStatus = this.options.isAdmin;

        this.options.disabledStatuses = null;
        let fnGetGreaterStatuses = (statusId) => {
                return _.filter(PJQ.constants.commitments.commitmentStatus, (st) => {
                    return st < statusId;
                });
            },
            status = this.model.get('statusId');
        if (status === PJQ.constants.commitments.commitmentStatus.APPROVED ||
            status === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_COMPLETE) {
            this.options.canAddChangeOrders = PJQ.app.session.project.hasPermission('commitmentChangeOrders.canAdd');
            this.options.canAddInvoices = PJQ.app.session.project.hasPermission('payableInvoices.canAdd');
        } else {
            this.options.canAddChangeOrders = false
            this.options.canAddInvoices = false;
        }

        let isContractedContact = (PJQ.app.session.contact && PJQ.app.session.contact.id === this.model.get('contractedContactId')) ||
            (this.model.contractedContact != null && PJQ.app.session.user.id === this.model.contractedContact.get('userId'));
        this.options.isSubmitting = isContractedContact && (status === PJQ.constants.commitments.commitmentStatus.DRAFT
            || status === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_OUT_FOR_BID
            || status === PJQ.constants.commitments.commitmentStatus.OUT_FOR_SIGNATURE);

        if (status === PJQ.constants.commitments.commitmentStatus.DRAFT) {
            this.options.canEdit = isContractedContact || this.options.hasEditPermission;
            this.options.canEditDates = this.options.canEdit;
            this.options.canUploadAttachments = this.options.canEdit;
            this.options.canEditLineItems = PJQ.app.session.project.hasPermission('commitments.canEditLineItems');
        } else if (status === PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_PROCESSING
            || status === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_OUT_FOR_BID) {
            this.options.canUploadAttachments = isContractedContact || this.options.canEdit;
            this.options.canEditLineItems = isContractedContact || PJQ.app.session.project.hasPermission('commitments.canEditLineItems');
        } else if (status === PJQ.constants.commitments.commitmentStatus.OUT_FOR_SIGNATURE) {
            this.options.canUploadAttachments = isContractedContact || this.options.canEdit;
            this.options.canEditLineItems = this.options.isAdmin;
        } else if (status === PJQ.constants.commitments.commitmentStatus.APPROVED
            || status === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_COMPLETE
            || status === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_TERMINATED
            || status === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_VOID
            || status === PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_CLOSED) {
            this.options.canEditLineItems = false;
            this.options.canDelete = false;
        } else if (status === PJQ.constants.commitments.commitmentStatus.SUBMITTED) {
            this.options.canEditLineItems = false;
        }

        if (this.model.invoices.models.length > 0) {
            this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.commitments.commitmentStatus.APPROVED);
            this.options.canEditLineItems = false;
        }

        if (this.erpIntegration != null) {
            let syncStatus = this.model.erpSyncStatus();
            if (syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED
            ) {
                this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.commitments.commitmentStatus.APPROVED);
                this.options.canEdit = false;
                this.options.canEditLineItems = false;
                this.options.canDelete = false;
                this.options.isSubmitting = false;
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            erpIntegration: this.erpIntegration,
            customFields: this.customFields,
            canViewChangeOrders: this.options.canViewChangeOrders,
            canAddChangeOrders: this.options.canAddChangeOrders,
            canViewInvoices: this.options.canViewInvoices,
            canAddInvoices: this.options.canAddInvoices,
            isSubmitting: this.options.isSubmitting,
            canEdit: this.options.canEdit,
            canUploadAttachments: this.options.canUploadAttachments,
            canEditLineItems: this.options.canEditLineItems,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched,
            activeView: this.options.activeView,
            views: this.views,
            terms: this.terms,
            settings: this.settings,
            invoiceSettings: this.invoiceSettings,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this),
            uploadCustomFields: this.uploadCustomFields,
            hasPendingInvoice: this.model && this.model.invoices.models.length > 0 && null != _.find(this.model.invoices.models, (invoice) => {
                return invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED
                    && invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE;
            })
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        window.testModel = this.model;

        this.activateView(this.options.activeView);

        this.stopListening(this.model.markupItems);
        this.listenTo(this.model.markupItems, 'update', (markup) => {
            if (markup && markup.get('delete') && (markup.lineItem || markup.get('lineItemId'))) {
                let lineItem = markup.lineItem ?? this.model.lineItems.findWhere({appliedMarkupId: markup.id});

                if (lineItem) {
                    if (lineItem.get('id') > 0) {
                        lineItem.set('delete', true);
                    } else {
                        this.model.lineItems.remove(lineItem);
                    }
                }
            }

            this.updateCounts();
            this.lineItemsView.render();
        });

        this.stopListening(this.model);
        this.listenTo(this.model, 'change:statusId', () => {
            this.renderERP();
        });
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderGeneral();

        this.renderLineItems();
        if (!this.model.isNew()) {
            if (this.options.canViewChangeOrders) {
                this.renderChangeOrders();
            }
            if (this.options.canViewInvoices) {
                this.renderInvoices();
                this.renderPayments();
            }
        }
        this.renderMarkups();
        this.updateCounts();

        let checkRetainage = PJQ.app.session.erpIntegration?.checkAvailableAction(PJQ.constants.integrations.actions.CAN_RELEASE_COMMITMENT_RETAINAGE, this.model);
        if (_.size(checkRetainage?.alert?.text) > 0) {
            new PJQ.Alert(this.$('.modal-body'), {
                type: checkRetainage.alert.type ?? 'warning',
                text: checkRetainage.alert.text,
                extraClasses: ['mt-2'],
                isPrepend: true
            });
        }
    },
    updateCounts: function () {
        this.$('.count-line-items').text(_.size(_.filter(this.model.lineItems.models, (item) => {
            return !item.get('delete');
        })));
        this.$('.count-change-orders').text(_.size(this.model.changeOrders.models));
        this.$('.count-invoices').text(_.size(this.model.invoices.models));
        this.$('.count-payments').text(_.size(this.model.payments.models));
        this.$('.count-markups').text(_.size(_.filter(this.model.markupItems.models, function (item) {
            return !item.get('delete');
        })));
    },
    views: {
        GENERAL: 'C_General',
        LINEITEMS: 'C_LineItems',
        CHANGEORDERS: 'C_ChangeOrders',
        INVOICES: 'C_Invoices',
        PAYMENTS: 'C_Payments',
        MARKUPS: 'C_Markups',
        HISTORY: 'C_History'
    },
    activeViewChanged: function (e) {
        let view = e.target.hash ? e.target.hash.replace('#', '') : null;
        this.activateView(view);
    },
    activateView: function (view) {
        switch (view) {
            case this.views.LINEITEMS:
            case this.views.CHANGEORDERS:
            case this.views.INVOICES:
            case this.views.PAYMENTS:
            case this.views.MARKUPS:
                // do nothing
                break;
            default:
                view = this.views.GENERAL;
                break;
        }

        this.$('.nav-link[href="#' + view + '"]').tab('show');
        this.options.activeView = view;
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$('.general-pane'), this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        let choices = [];
        _.each(PJQ.constants.commitments.commitmentStatus, (st) => {
            if (this.model.get('commitmentType') === PJQ.constants.commitments.commitmentType.SUBCONTRACT
                && (st === PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_PROCESSING
                    || st === PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_PARTIALLY_RECEIVED
                    || st === PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_RECEIVED
                    || st === PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_CLOSED)) {
                return;
            } else if (this.model.get('commitmentType') === PJQ.constants.commitments.commitmentType.PURCHASE_ORDER
                && (st === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_OUT_FOR_BID
                    || st === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_COMPLETE
                    || st === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_TERMINATED
                    || st === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_VOID)) {
                return;
            }

            choices.push({
                id: st,
                name: PJQ.constants.commitments.commitmentStatusNames[st],
                disabled: this.options.disabledStatuses != null && this.options.disabledStatuses.indexOf(st) > -1
            });
        });
        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            choices: choices,
            isIntChoices: true,
            defaultValue: this.model.get('statusId'),
            canEdit: this.options.canEditStatus,
            onChange: (newStatus) => {
                let oldStatus = this.model.get('statusId');
                if (newStatus === oldStatus) {
                    return;
                }

                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.save((success) => {
                        if (success) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Commitment saved successfully'
                            });
                        } else {
                            this.model.set('statusId', oldStatus);
                            this.statusPicker.setValue(oldStatus);
                        }
                    })
                } else {
                    this.render();
                }
            }
        });

        let defaultTerm = _.find(this.terms.models, function (model) {
            return model.get('isDefault');
        }, this);
        if (this.model.isNew() && defaultTerm != null && defaultTerm.id > 0) {
            this.model.set('termsId', defaultTerm.id);
        }
        this.termsPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-terms'),
            isIntChoices: true,
            defaultValue: this.model.get('termsId'),
            noneSelectedText: this.options.canEdit && this.options.isAdmin ? 'Select Value' : 'Not Selected',
            canEdit: this.options.canEdit && this.options.isAdmin,
            onChange: _.bind(function (newTermsId) {
                this.model.set('termsId', newTermsId ? newTermsId : 0);
            }, this)
        });

        this.contractCompanyPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.contracted-company'),
            selectedContact: this.model.contractedContact,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: !this.model.isERPSynced() && (this.options.canEdit && this.options.isAdmin),
            hideUsers: true,
            displayContactsBlock: true,
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            isSingleChoice: true,
            onChange: _.bind(function (selectedContact) {
                this.model.contractedContact = selectedContact;
                this.model.set('contractedContactId', selectedContact ? selectedContact.id : null);
            }, this)
        });

        this.invoiceContactPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.invoice-contact'),
            selectedContact: this.model.invoiceContact,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEditInvoiceContact && this.options.isAdmin,
            displayContactsBlock: true,
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            hideUsers: true,
            isSingleChoice: true,
            onChange: _.bind(function (selectedContact) {
                this.model.invoiceContact = selectedContact;
                this.model.set('invoiceContactId', selectedContact ? selectedContact.id : null);
            }, this)
        });

        if (_.size(this.customFields) > 0) {
            this.commitmentCustomFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.commitment-custom-fields'),
                canEdit: this.options.canEdit,
                isAdmin: this.options.isAdmin,
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                onChange: _.bind(function () {
                    this.model.isDirty = true;
                }, this)
            });
        }

        new PJQ.inputs.Datepicker({
            el: this.$('.start-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('startDate')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('startDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.est-complete-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('estimatedCompletionDate')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('estimatedCompletionDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.act-complete-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('actualCompletionDate')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('actualCompletionDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.contract-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('contractDate')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('contractDate', newDate);
            }, this)
        });

        if (this.model.get('commitmentType') === PJQ.constants.commitments.commitmentType.PURCHASE_ORDER) {
            new PJQ.inputs.Datepicker({
                el: this.$('.delivery-date'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('deliveryDate')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('deliveryDate', newDate);
                }, this)
            });

            let bTo = this.model.get('billTo');
            if (bTo == null) {
                bTo = {};
            }

            if (_.size(bTo.country) === 0) {
                bTo.country = 'US';
            }

            this.billToStatePicker = new PJQ.inputs.StatePicker({
                el: this.$('.billto-state'),
                country: bTo.country,
                defaultValue: bTo.state,
                size: 20,
                onChange: (value) => {
                    let billTo = this.model.get('billTo');
                    billTo.state = value;
                    this.model.set('billTo', billTo);
                }
            });

            this.billToCountryPicker = new PJQ.inputs.CountryPicker({
                el: this.$('.billto-country'),
                defaultValue: bTo.country,
                statePicker: this.billToStatePicker,
                zipInput: this.$('.billto-zip'),
                enableInternational: this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_INTERNATIONAL_COUNTRIES),
                size: 20,
                onChange: (value) => {
                    let billTo = this.model.get('billTo');
                    billTo.country = value;
                    this.model.set('billTo', billTo);
                }
            });

            PJQ.helpers.inputHelpers.inputMaskPhone(this.$('input.billto-phone'));
            PJQ.helpers.inputHelpers.inputMaskPhone(this.$('input.billto-fax'));

            let sTo = this.model.get('shipTo');
            if (sTo == null) {
                sTo = {};
            }

            if (_.size(sTo.country) === 0) {
                sTo.country = 'US';
            }

            this.shipToStatePicker = new PJQ.inputs.StatePicker({
                el: this.$('.shipto-state'),
                country: sTo.country,
                defaultValue: sTo.state,
                size: 20,
                onChange: (value) => {
                    let shipTo = this.model.get('shipTo');
                    shipTo.state = value;
                    this.model.set('shipTo', shipTo);
                }
            });

            this.shipToCountryPicker = new PJQ.inputs.CountryPicker({
                el: this.$('.shipto-country'),
                defaultValue: sTo?.country,
                statePicker: this.shipToStatePicker,
                zipInput: this.$('.shipto-zip'),
                enableInternational: this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_INTERNATIONAL_COUNTRIES),
                size: 20,
                onChange: (value) => {
                    let shipTo = this.model.get('shipTo');
                    shipTo.country = value;
                    this.model.set('shipTo', shipTo);
                }
            });

            PJQ.helpers.inputHelpers.inputMaskPhone(this.$('input.shipto-phone'));
            PJQ.helpers.inputHelpers.inputMaskPhone(this.$('input.shipto-fax'));
        }

        if (this.model.get('commitmentType') === PJQ.constants.commitments.commitmentType.SUBCONTRACT) {
            new PJQ.inputs.Datepicker({
                el: this.$('.signed-contract-date'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('signedContractReceivedDate')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('signedContractReceivedDate', newDate);
                }, this)
            });

            new PJQ.inputs.Datepicker({
                el: this.$('.execution-date'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('executionDate')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('executionDate', newDate);
                }, this)
            });

            new PJQ.inputs.Datepicker({
                el: this.$('.issued-date'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('issuedOnDate')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('issuedOnDate', newDate);
                }, this)
            });

            new PJQ.inputs.Datepicker({
                el: this.$('.returned-date'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('returnedDate')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('returnedDate', newDate);
                }, this)
            });

            new PJQ.inputs.Datepicker({
                el: this.$('.letter-intent-date'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('letterOfIntentDate')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('letterOfIntentDate', newDate);
                }, this)
            });

            new PJQ.inputs.Datepicker({
                el: this.$('.approval-letter-date'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('approvalLetterDate')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('approvalLetterDate', newDate);
                }, this)
            });
        }

        if (this.checkFieldVisible('attachments')) {
            let $att = this.$('.commitment-file-uploader');
            if (_.size(this.model.attachments.models) === 0 && !this.options.canUploadAttachments) {
                $att.closest('.upload-outer').hide();
            } else {
                this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                    el: $att,
                    collection: this.model.attachments,
                    canUpload: this.options.canUploadAttachments,
                    useApiV2: true,
                    canView: false,
                    useBlob: true,
                    canDelete: this.options.isAdmin,
                    previewImageDimension: 150,
                    onSuccess: _.bind(function (file) {
                        this.model.isDirty = true;
                        this.fileUploader.clearError();
                    }, this),
                    onDelete: _.bind(function (attachment, callback) {
                        if (attachment.get('id') > 0) {
                            attachment.set('delete', true);
                        } else {
                            attachment.destroy();
                        }

                        this.model.isDirty = true;
                        callback();
                    }, this)
                });
            }
        }

        if (this.checkFieldVisible('coiAttachments')) {
            let $coi = this.$('.coi-file-uploader');
            if (_.size(this.model.coiAttachments.models) === 0 && !this.options.canUploadAttachments) {
                $coi.closest('.upload-outer').hide();
            } else {
                this.coiUploader = new PJQ.views.files.FileUploaderGrid({
                    el: $coi,
                    collection: this.model.coiAttachments,
                    canUpload: this.options.canUploadAttachments,
                    useApiV2: true,
                    canView: false,
                    useBlob: true,
                    canDelete: this.options.isAdmin,
                    previewImageDimension: 150,
                    onSuccess: _.bind(function (file) {
                        this.model.isDirty = true;
                        this.coiUploader.clearError();
                    }, this),
                    onDelete: _.bind(function (attachment, callback) {
                        if (attachment.get('id') > 0) {
                            attachment.set('delete', true);
                        } else {
                            attachment.destroy();
                        }

                        this.model.isDirty = true;
                        callback();
                    }, this)
                });
                this.renderCOIApproval();
            }
        }

        if (this.checkFieldVisible('w9Attachments')) {
            let $w9 = this.$('.w9-file-uploader');
            if (_.size(this.model.w9Attachments.models) === 0 && !this.options.canUploadAttachments) {
                $w9.closest('.upload-outer').hide();
            } else {
                this.w9Uploader = new PJQ.views.files.FileUploaderGrid({
                    el: $w9,
                    collection: this.model.w9Attachments,
                    canUpload: this.options.canUploadAttachments,
                    useApiV2: true,
                    canView: false,
                    useBlob: true,
                    canDelete: this.options.isAdmin,
                    previewImageDimension: 150,
                    onSuccess: _.bind(function (file) {
                        this.model.isDirty = true;
                        this.w9Uploader.clearError();
                    }, this),
                    onDelete: _.bind(function (attachment, callback) {
                        if (attachment.get('id') > 0) {
                            attachment.set('delete', true);
                        } else {
                            attachment.destroy();
                        }

                        this.model.isDirty = true;
                        callback();
                    }, this)
                });
                this.renderW9Approval();
            }
        }

        if (this.checkFieldVisible('lienWaiverAttachments')) {
            let $lien = this.$('.lien-waiver-file-uploader');
            if (_.size(this.model.lienWaiverAttachments.models) === 0 && !this.options.canUploadAttachments) {
                $lien.closest('.upload-outer').hide();
            } else {
                this.lienWaiverUploader = new PJQ.views.files.FileUploaderGrid({
                    el: $lien,
                    collection: this.model.lienWaiverAttachments,
                    canUpload: this.options.canUploadAttachments,
                    useApiV2: true,
                    canView: false,
                    useBlob: true,
                    canDelete: this.options.isAdmin,
                    previewImageDimension: 150,
                    onSuccess: _.bind(function (file) {
                        this.model.isDirty = true;
                        this.lienWaiverUploader.clearError();
                    }, this),
                    onDelete: _.bind(function (attachment, callback) {
                        if (attachment.get('id') > 0) {
                            attachment.set('delete', true);
                        } else {
                            attachment.destroy();
                        }

                        this.model.isDirty = true;
                        callback();
                    }, this)
                });
                this.renderLienWaiverApproval();
            }
        }

        if (this.checkFieldVisible('signedDocumentAttachments')) {
            let $signed = this.$('.signed-file-uploader');
            if (_.size(this.model.signedDocumentAttachments.models) === 0 && !this.options.canUploadAttachments) {
                $signed.closest('.upload-outer').hide();
            } else {
                this.signedDocumentUploader = new PJQ.views.files.FileUploaderGrid({
                    el: $signed,
                    collection: this.model.signedDocumentAttachments,
                    canUpload: this.options.canUploadAttachments,
                    useApiV2: true,
                    canView: false,
                    useBlob: true,
                    canDelete: this.options.isAdmin,
                    previewImageDimension: 150,
                    onSuccess: _.bind(function (file) {
                        this.model.isDirty = true;
                        this.signedDocumentUploader.clearError();
                    }, this),
                    onDelete: _.bind(function (attachment, callback) {
                        if (attachment.get('id') > 0) {
                            attachment.set('delete', true);
                        } else {
                            attachment.destroy();
                        }

                        this.model.isDirty = true;
                        callback();
                    }, this)
                });
            }
        }

        if (this.checkFieldVisible('affidavitAttachments')) {
            let $affidavit = this.$('.affidavit-file-uploader');
            if (_.size(this.model.affidavitAttachments.models) === 0 && !this.options.canUploadAttachments) {
                $affidavit.closest('.upload-outer').hide();
            } else {
                this.affidavitUploader = new PJQ.views.files.FileUploaderGrid({
                    el: $affidavit,
                    collection: this.model.affidavitAttachments,
                    canUpload: this.options.canUploadAttachments,
                    useApiV2: true,
                    canView: false,
                    useBlob: true,
                    canDelete: this.options.isAdmin,
                    previewImageDimension: 150,
                    onSuccess: _.bind(function (file) {
                        this.model.isDirty = true;
                        this.affidavitUploader.clearError();
                    }, this),
                    onDelete: _.bind(function (attachment, callback) {
                        if (attachment.get('id') > 0) {
                            attachment.set('delete', true);
                        } else {
                            attachment.destroy();
                        }

                        this.model.isDirty = true;
                        callback();
                    }, this)
                });
            }
        }

        if (this.checkFieldVisible('executedDocumentAttachments')) {
            let $executed = this.$('.executed-file-uploader'),
                canUpload = this.options.canUploadAttachments && this.options.isAdmin;
            if (_.size(this.model.executedDocumentAttachments.models) === 0 && !canUpload) {
                $executed.closest('.upload-outer').hide();
            } else {
                this.executedDocumentUploader = new PJQ.views.files.FileUploaderGrid({
                    el: $executed,
                    collection: this.model.executedDocumentAttachments,
                    canUpload: canUpload,
                    useApiV2: true,
                    canView: false,
                    useBlob: true,
                    canDelete: this.options.isAdmin,
                    previewImageDimension: 150,
                    onSuccess: _.bind(function (file) {
                        this.model.isDirty = true;
                        this.executedDocumentUploader.clearError();
                    }, this),
                    onDelete: _.bind(function (attachment, callback) {
                        if (attachment.get('id') > 0) {
                            attachment.set('delete', true);
                        } else {
                            attachment.destroy();
                        }

                        this.model.isDirty = true;
                        callback();
                    }, this)
                });
            }
        }

        if (_.size(this.uploadCustomFields) > 0) {
            this.renderUploadCustomFields();
        }
    },
    renderUploadCustomFields: function () {
        this.customFieldUploaders = [];
        _.each(this.uploadCustomFields, function (field) {
            let type = 'cf-' + field.id,
                $upload = this.$("." + type + '-file-uploader'),
                canUpload = this.options.canUploadAttachments && (!field.get('isAdminEdit') || this.options.isAdmin),
                customFieldAttachments = _.filter(this.model.customFieldAttachments.models, function (attachment) {
                    return attachment.get('type') === type;
                });

            if (_.size(customFieldAttachments) === 0 && !canUpload) {
                $upload.closest('.upload-outer').hide();
                return;
            }

            let attachmentsCollection = new PJQ.collections.commitments.CommitmentAttachments(customFieldAttachments);
            let uploader = new PJQ.views.files.FileUploaderGrid({
                el: $upload,
                collection: attachmentsCollection,
                canUpload: canUpload,
                useApiV2: true,
                canView: false,
                useBlob: true,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                    uploader.clearError();

                    let newAttachment = _.find(attachmentsCollection.models, function (attachment) {
                        return attachment.get('uploadId') === file.uploadId;
                    });

                    if (newAttachment != null) {
                        newAttachment.set('type', type);
                        this.model.customFieldAttachments.add(newAttachment);
                    }
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        let customFieldAttachment = this.model.customFieldAttachments.findWhere({id: attachment.get('id')});

                        attachment.set('delete', true);
                        if (customFieldAttachment != null) {
                            customFieldAttachment.set('delete', true);
                        }
                    } else {
                        let customFieldAttachment = this.model.customFieldAttachments.findWhere({uploadId: attachment.get('uploadId')});

                        attachment.destroy();
                        if (customFieldAttachment != null) {
                            this.model.customFieldAttachments.remove(customFieldAttachment);
                        }
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
            this.customFieldUploaders.push(uploader);
        }, this);
    },
    renderCOIApproval: function () {
        if (this.coiApproval != null) {
            this.coiApproval.remove();
        }
        if (this.model.get('isCOIRequired')) {
            this.coiApproval = new PJQ.inputs.ButtonGroup({
                el: this.$('.coi-approval'),
                canEdit: this.options.canEdit && this.options.isAdmin,
                colorInactiveButtons: false,
                buttonClasses: 'wd-120p',
                buttons: [
                    {
                        label: "Not Reviewed",
                        value: null,
                        colorClass: "light"
                    },
                    {
                        label: "Rejected",
                        value: false,
                        colorClass: "danger"
                    },
                    {
                        label: "Approved",
                        value: true,
                        colorClass: "success"
                    }
                ],
                defaultValue: this.model.get('isCOIApproved'),
                onChange: _.bind(function (value) {
                    this.model.set('isCOIApproved', value);
                }, this)
            });
        }
    },
    renderW9Approval: function () {
        if (this.w9Approval != null) {
            this.w9Approval.remove();
        }
        if (this.model.get('isW9Required')) {
            this.w9Approval = new PJQ.inputs.ButtonGroup({
                el: this.$('.w9-approval'),
                canEdit: this.options.canEdit && this.options.isAdmin,
                colorInactiveButtons: false,
                buttonClasses: 'wd-120p',
                buttons: [
                    {
                        label: "Not Reviewed",
                        value: null,
                        colorClass: "light"
                    },
                    {
                        label: "Rejected",
                        value: false,
                        colorClass: "danger"
                    },
                    {
                        label: "Approved",
                        value: true,
                        colorClass: "success"
                    }
                ],
                defaultValue: this.model.get('isW9Approved'),
                onChange: _.bind(function (value) {
                    this.model.set('isW9Approved', value);
                }, this)
            });
        }
    },
    renderLienWaiverApproval: function () {
        if (this.lienWaiverApproval != null) {
            this.lienWaiverApproval.remove();
        }
        if (this.model.get('isLienWaiverRequired')) {
            this.lienWaiverApproval = new PJQ.inputs.ButtonGroup({
                el: this.$('.lien-waiver-approval'),
                canEdit: this.options.canEdit && this.options.isAdmin,
                colorInactiveButtons: false,
                buttonClasses: 'wd-120p',
                buttons: [
                    {
                        label: "Not Reviewed",
                        value: null,
                        colorClass: "light"
                    },
                    {
                        label: "Rejected",
                        value: false,
                        colorClass: "danger"
                    },
                    {
                        label: "Approved",
                        value: true,
                        colorClass: "success"
                    }
                ],
                defaultValue: this.model.get('isLienWaiverApproved'),
                onChange: _.bind(function (value) {
                    this.model.set('isLienWaiverApproved', value);
                }, this)
            });
        }
    },
    formatPercent: function (e) {
        $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatPercent($(e.currentTarget).val()));
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e, true, true);
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisible');
            }
        }
        return true;
    },
    checkFieldRequired: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isRequired');
            }
        }
        return false;
    },
    renderLineItems() {
        if (this.lineItemsView) {
            this.lineItemsView.remove();
        }

        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.commitment-line-items'),
            collection: this.model.lineItems,
            commitment: this.model,
            lineItemModel: PJQ.models.commitments.CommitmentLineItem,
            accountingMethod: this.model.get('accountingMethod'),
            canEdit: this.options.canEditLineItems,
            canDelete: this.options.canEditLineItems,
            canChangeAccountingMethod: this.options.isSubmitting || this.options.canEditLineItems,
            financialMarkups: this.model.markupItems,
            enableTax: true,
            billedToDate: this.options.canViewInvoices && this.model.invoices != null ? () => {
                let res = 0;
                _.each(this.model.invoices.models, function (invoice) {
                    if (invoice.get('statusId') === PJQ.constants.invoicing.payableInvoiceStatus.APPROVED
                        || invoice.get('statusId') === PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE) {
                        res += invoice.getGrandTotal();
                    }
                });
                return res;
            } : null,
            retainage: this.options.canViewInvoices && this.model.invoices != null ? () => {
                let res = 0;
                _.each(this.model.invoices.models, function (invoice) {
                    if (invoice.get('statusId') === PJQ.constants.invoicing.payableInvoiceStatus.APPROVED
                        || invoice.get('statusId') === PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE) {
                        res += (invoice.getRetainage() - invoice.getRetainageReleased());
                    }
                });
                return res;
            } : null,
            showBilling: this.model.get('statusId') === PJQ.constants.commitments.commitmentStatus.APPROVED || this.model.get('statusId') === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_COMPLETE,
            approvedChanges: this.model.get('approvedChanges'),
            onApprovedChangesClicked: () => {
                this.activateView(this.views.CHANGEORDERS);
            },
            onBilledToDateClicked: () => {
                this.activateView(this.views.INVOICES);
            },
            showSubTotal: true,
            showGrandTotal: true,
            onAccountingMethodChanged: _.bind(function (value) {
                this.model.set('accountingMethod', value);
            }, this),
            onLineItemChange: _.bind(function () {
                this.model.isDirty = true;
            }, this),
            onLineItemAdd: _.bind(function () {
                this.updateCounts();
            }, this),
            onLineItemDelete: _.bind(function () {
                this.updateCounts();
            }, this)
        });
    },
    copyToHelper: function (e) {
        let from = $(e.currentTarget).data('from'),
            to = $(e.currentTarget).data('to'),
            contact = {},
            fromDescription = '',
            toDescription = '',
            fnContinue = () => {
                new PJQ.views.modals.YesNo({
                    header: 'Copy to ' + toDescription,
                    body: 'Are you sure you want to overwrite the ' + toDescription + ' based on the ' + fromDescription + '?',
                    onYes: _.bind(function () {

                        this.model.attributes[to].companyName = contact.companyName;
                        this.model.attributes[to].contactName = contact.contactName;
                        this.model.attributes[to].address1 = contact.address1;
                        this.model.attributes[to].address2 = contact.address2;
                        this.model.attributes[to].city = contact.city;
                        this.model.attributes[to].state = contact.state;
                        this.model.attributes[to].zip = contact.zip;
                        this.model.attributes[to].country = contact.country;
                        this.model.attributes[to].phone = contact.phone;
                        this.model.attributes[to].fax = contact.fax;
                        this.model.attributes[to].email = contact.email;

                        this.$('.' + to.toLowerCase() + '-companyname').val(contact.companyName);
                        this.$('.' + to.toLowerCase() + '-contactname').val(contact.contactName);
                        this.$('.' + to.toLowerCase() + '-address1').val(contact.address1);
                        this.$('.' + to.toLowerCase() + '-address2').val(contact.address2);
                        this.$('.' + to.toLowerCase() + '-city').val(contact.city);
                        this.$('.' + to.toLowerCase() + '-phone').val(contact.phone);
                        this.$('.' + to.toLowerCase() + '-fax').val(contact.fax);
                        this.$('.' + to.toLowerCase() + '-email').val(contact.email);

                        if (to === 'billTo')
                            this.billToCountryPicker.setValue(contact.country);
                        else if (to === 'shipTo')
                            this.shipToCountryPicker.setValue(contact.country);

                        if (to === 'billTo')
                            this.billToStatePicker.setValue(contact.state);
                        else if (to === 'shipTo')
                            this.shipToStatePicker.setValue(contact.state);

                        this.$('.' + to.toLowerCase() + '-zip').val(contact.zip);
                    }, this),
                });
            };

        switch (from) {
            case 'shipTo':
                fromDescription = 'Ship To';
                contact.companyName = this.$('.shipto-companyname').val();
                contact.contactName = this.$('.shipto-contactname').val();
                contact.address1 = this.$('.shipto-address1').val();
                contact.address2 = this.$('.shipto-address2').val();
                contact.city = this.$('.shipto-city').val();
                contact.state = this.shipToStatePicker.getValue().toUpperCase();
                contact.zip = this.$('.shipto-zip').val();

                let sCountry = this.shipToCountryPicker.getValue().toUpperCase();
                contact.country = _.size(sCountry) === 0 ? 'US' : sCountry;
                contact.phone = this.$('.shipto-phone').val();
                contact.fax = this.$('.shipto-fax').val();
                contact.email = this.$('.shipto-email').val();
                break;
            case 'billTo':
                fromDescription = 'Bill To';
                contact.companyName = this.$('.billto-companyname').val();
                contact.contactName = this.$('.billto-contactname').val();
                contact.address1 = this.$('.billto-address1').val();
                contact.address2 = this.$('.billto-address2').val();
                contact.city = this.$('.billto-city').val();
                contact.state = this.billToStatePicker.getValue().toUpperCase();
                contact.zip = this.$('.billto-zip').val();

                let bCountry = this.billToCountryPicker.getValue().toUpperCase();
                contact.country = _.size(bCountry) === 0 ? 'US' : bCountry;
                contact.phone = this.$('.billto-phone').val();
                contact.fax = this.$('.billto-fax').val();
                contact.email = this.$('.billto-email').val();
                break;
            case 'project':
                fromDescription = 'Project';
                contact.address1 = PJQ.app.session.project.get('address1');
                contact.address2 = PJQ.app.session.project.get('address2');
                contact.city = PJQ.app.session.project.get('city');
                contact.state = PJQ.app.session.project.get('state');
                contact.zip = PJQ.app.session.project.get('zip');
                contact.country = PJQ.app.session.project.get('country');
                break;
        }

        switch (to) {
            case 'shipTo':
                toDescription = 'Ship To';
                break;
            case 'billTo':
                toDescription = 'Bill To';
                break;
        }

        if (from === 'addressBook') {
            fromDescription = 'Address Book';

            new PJQ.views.contacts.SelectContactsModal({
                context: PJQ.constants.contacts.contexts.CONTACTS,
                isSingleChoice: true,
                onSave: _.bind(function (data) {
                    contact.companyName = data.get('companyName');
                    contact.contactName = data.get('contactName');
                    contact.address1 = data.get('address1');
                    contact.address2 = data.get('address2');
                    contact.city = data.get('city');
                    contact.state = data.get('state');
                    contact.zip = data.get('zip');

                    let country = data.get('country');
                    contact.country = _.size(country) === 0 ? 'US' : country;
                    contact.phone = data.get('phone');
                    contact.fax = data.get('fax');
                    contact.email = data.get('email');

                    fnContinue();
                }, this)
            });
        } else
            fnContinue();
    },
    renderChangeOrders: function () {
        if (this.model.isNew()) {
            return;
        }

        this.changeOrdersDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.commitment-change-orders'),
            data: this.model.changeOrders.models,
            isHideSearch: true,
            language: {
                emptyTable: this.options.canAddChangeOrders ? 'Click "New Change Order" to create a Commitment Change Order' : 'No change orders have been created'
            },
            paging: false,
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewChangeOrder(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewChangeOrders;
                        }, this)
                    }
                ]
            },
            order: [1, 'asc'],
            hasFooter: true,
            columns: [
                {
                    "columnData": "",
                    "data": null,
                    "title": "",
                    "width": "40px",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        let exObj = row.get('externalObject');
                        if (exObj == null) {
                            return '';
                        }

                        return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                    }
                }, {
                    "data": "attributes.number",
                    "title": "Number",
                    "width": '200px',
                    "render": (data, type, row) => {
                        if (type === 'sort') {
                            return row.id;
                        }

                        return '<a href="javascript:void(0)" class="btn-view-change-order">' + data + '</a>'
                    }
                }, {
                    "data": "attributes.description",
                    "title": "Description",
                }, {
                    "columnData": "createdOn",
                    "data": "attributes.createdOn",
                    "title": 'Created',
                    "width": '180px',
                    "render": (data, type, row) => {
                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                    }
                }, {
                    "data": "attributes.invoicedDate",
                    "title": 'Invoiced Date',
                    "width": '140px',
                    "render": (data, type, row) => {
                        if (_.size(row.get('invoicedDate')) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('invoicedDate')), PJQ.helpers.dateHelpers.dateFormats.DATE);
                    }
                }, {
                    "data": "attributes.dueDate",
                    "title": 'Due Date',
                    "width": '140px',
                    "render": (data, type, row) => {
                        if (_.size(row.get('dueDate')) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('dueDate')), PJQ.helpers.dateHelpers.dateFormats.DATE);
                    }
                }, {
                    "data": "attributes.statusId",
                    "title": "Status",
                    "width": '150px',
                    "render": (data, type, row) => {
                        return PJQ.constants.commitments.changeOrderStatusNames[row.get('statusId')];
                    }
                }, {
                    "data": "attributes.amount",
                    "title": "Grand Total",
                    "width": '120px',
                    "render": (data, type, row) => {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    },
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (changeOrder) {
                            amt += changeOrder.getGrandTotal();
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                }, {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": "80px",
                    "render": (data, type, row) => {
                        let html = '<div class="text-align-right show-on-row-hover">';
                        if (this.options.canViewChangeOrders) {
                            html += '<button type="button" class="btn btn-info btn-view-change-order ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        return html + '</div>';
                    }
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            onRowDoubleClick: _.bind(function (row) {
                this.viewChangeOrder(row.data());
            }, this)
        });
    },
    newChangeOrder: function () {
        this.viewChangeOrder();
    },
    newInvoice: function () {
        this.viewInvoice();
    },
    viewChangeOrderClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.changeOrdersDataTable.getRow(target.closest('tr'));
        this.viewChangeOrder(row.data());
    },
    viewChangeOrder: function (changeOrder) {
        this.removeModal();
        new PJQ.views.commitments.ChangeOrderEditModal({
            commitment: this.model,
            model: changeOrder,
            onSave: _.bind(function (changeOrder, isNew) {
                if (isNew) {
                    this.model.changeOrders.add(changeOrder);
                    this.changeOrdersDataTable.addRow(changeOrder);

                    if (typeof this.options.onChangeOrderAdd === 'function') {
                        this.options.onChangeOrderAdd(changeOrder);
                    }
                } else {
                    this.changeOrdersDataTable.refresh();
                }
                this.model.set('changeOrders', this.model.changeOrders.toJSON());
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function (changeOrderId) {
                this.changeOrdersDataTable.render();
                this.model.set('changeOrders', this.model.changeOrders.toJSON());

                if (typeof this.options.onChangeOrderDelete === 'function') {
                    this.options.onChangeOrderDelete(changeOrderId);
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    deleteChangeOrder: function (changeOrder) {
        let row = this.changeOrdersDataTable.getRow(changeOrder.cid),
            changeOrderId = row.data().id;
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Change Order",
            body: "Are you sure you want to delete this change order?",
            onDelete: _.bind(function () {
                this.model.changeOrders.remove(changeOrder);
                this.model.set('changeOrders', this.model.changeOrders.toJSON());
                changeOrder.destroy({
                    success: _.bind(function () {
                        this.changeOrdersDataTable.removeRow(row);

                        if (typeof this.options.onChangeOrderDelete === 'function') {
                            this.options.onChangeOrderDelete(changeOrderId);
                        }
                        this.updateCounts();
                    }, this)
                });
            }, this)
        });
    },
    viewPaymentClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.paymentsDataTable.getRow(target.closest('tr'));
        this.viewPayment(row.data());
    },
    viewPayment: function (payment) {
        this.removeModal();
        new PJQ.views.invoicing.InvoicePaymentModal({
            model: payment,
            isPayable: true,
            onSave: _.bind(function (payment, isNew) {
                if (isNew) {
                    let invoice = this.model.invoices.get(payment.get('invoiceId'));
                    if (invoice != null) {
                        invoice.payments.add(payment);
                    }

                    this.paymentsDataTable.addRow(invoice);
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function () {
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
        });
    },
    renderPayments: function () {
        if (this.model.isNew() || !this.invoiceSettings.get('enablePayments')) {
            return;
        }

        this.paymentsDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.c-payments'),
            data: this.model.payments.models,
            isHideSearch: true,
            language: {
                emptyTable: 'No Payments have been created yet',
                zeroRecords: "No Payments matched the search criteria"
            },
            paging: false,
            order: [1, 'asc'],
            hasFooter: true,
            columns: [{
                "columnData": "",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    let exObj = row.get('externalObject');
                    if (exObj == null) {
                        return '';
                    }

                    return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                }
            },
                {
                    "title": "#",
                    "data": "attributes.number",
                    "width": "200px",
                    "render": (data, type, row) => {
                        if (type === 'sort') {
                            return row.id;
                        }

                        return '<a href="javascript:void(0)" class="btn-view-payment">' + data + '</a>'
                    }
                },
                {
                    "title": "Check #",
                    "data": "attributes.checkNumber"
                },
                {
                    "title": 'Received',
                    "data": "",
                    "width": "120px",
                    "render": (data, type, row) => {
                        let dateReceived = row.get('dateReceived');
                        if (_.size(dateReceived) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(dateReceived), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }
                },
                {
                    "title": "Payment Method",
                    "data": "attributes.paymentMethod",
                    "render": (data, type, row) => {
                        return PJQ.constants.invoicing.paymentMethods.find(item => item.toLowerCase() === data.toLowerCase()) ?? '';
                    }
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "width": "120px",
                    "render": (data, type, row) => {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                    },
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (payment) {
                            amt += payment.get('amount');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": "80px",
                    "render": (data, type, row) => {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        if (this.options.canViewInvoices) {
                            html += '<button type="button" class="btn btn-info btn-view-payment ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        return html + '</div>';
                    }
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewPayment(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewInvoices;
                        }, this)
                    }
                ]
            },
            onRowDoubleClick: _.bind(function (row) {
                this.viewPayment(row.data());
            }, this)
        });
    },
    viewInvoiceClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.invoicesDataTable.getRow(target.closest('tr'));
        this.viewInvoice(row.data());
    },
    viewInvoice: function (invoice) {
        this.removeModal();
        new PJQ.views.invoicing.EditPayableInvoiceModal({
            commitment: this.model,
            model: invoice,
            onSave: _.bind(function (invoice, isNew) {
                if (isNew) {
                    this.model.invoices.add(invoice);
                    this.invoicesDataTable.addRow(invoice);

                    if (typeof this.options.onInvoiceAdd === 'function') {
                        this.options.onInvoiceAdd(invoice);
                    }
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function () {
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    deleteInvoice: function (invoice) {
        let row = this.invoicesDataTable.getRow(invoice.cid);
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Invoice",
            body: "Are you sure you want to delete this Invoice?",
            onDelete: _.bind(function () {
                invoice.destroy({
                    success: _.bind(function () {
                        this.invoicesDataTable.removeRow(row);
                        this.updateCounts();

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }
                    }, this)
                });
            }, this)
        });
    },
    renderInvoices: function () {
        if (this.model.isNew()) {
            return;
        }

        this.invoicesDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.commitment-invoices'),
            data: this.model.invoices.models,
            isHideSearch: true,
            language: {
                emptyTable: 'No Invoices have been created yet',
                zeroRecords: "No Invoices matched the search criteria"
            },
            paging: false,
            order: [1, 'asc'],
            hasFooter: true,
            columns: [
                {
                    "columnData": "",
                    "data": null,
                    "title": "",
                    "width": "40px",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        let exObj = row.get('externalObject');
                        if (exObj == null) {
                            return '';
                        }

                        return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                    }
                }, {
                    "title": "#",
                    "data": "attributes.number",
                    "render": (data, type, row) => {
                        if (type === 'sort') {
                            return row.id;
                        }

                        return '<a href="javascript:void(0)" class="btn-view-invoice">' + data + '</a>'
                    }
                },
                {
                    "title": 'Billing Period',
                    "data": "attributes.startDate",
                    "width": '200px',
                    "render": (data, type, row) => {
                        let periodStart = PJQ.helpers.dateHelpers.getDateString(new Date(row.get('startDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true),
                            periodEnd = PJQ.helpers.dateHelpers.getDateString(new Date(row.get('endDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);

                        return (periodStart) + ' - ' + (periodEnd);
                    }
                },
                {
                    "title": 'Due Date',
                    "data": "attributes.billingDate",
                    "width": '120px',
                    "render": (data, type, row) => {
                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('billingDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }
                },
                {
                    "data": "",
                    "title": "Status",
                    "width": "150px",
                    "render": (data, type, row) => {
                        return PJQ.constants.invoicing.payableInvoiceStatusNames[row.get('statusId')]
                    }
                },
                {
                    "data": "attributes.amount",
                    "title": "Retainage",
                    "width": "120px",
                    "render": (data, type, row) => {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getRetainage() - row.getRetainageReleased());
                    },
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (invoice) {
                            amt += invoice.getRetainage() - invoice.getRetainageReleased();
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "data": "attributes.amount",
                    "title": "Grand Total",
                    "width": "120px",
                    "render": (data, type, row) => {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    },
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (invoice) {
                            amt += invoice.getGrandTotal();
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": "80px",
                    "render": (data, type, row) => {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        if (this.options.canViewInvoices) {
                            html += '<button type="button" class="btn btn-info btn-view-invoice ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        // if (PJQ.app.session.project.hasPermission('payableInvoices.isAdmin')) {
                        //     html += '<button type="button" class="btn btn-danger delete-invoice ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button>'
                        // }
                        return html + '</div>';
                    }
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewInvoice(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewInvoices;
                        }, this)
                    }
                ]
            },
            onRowDoubleClick: _.bind(function (row) {
                let invoice = row.data();
                if (invoice != null && this.options.canViewInvoices) {
                    invoice.fetch({
                        success: _.bind(function () {
                            this.viewInvoice(invoice);
                        }, this)
                    });
                }
            }, this)
        });
    },
    validate: function () {
        let isValid = true;
        PJQ.helpers.inputHelpers.setInputError(this.$('.commitment-number, .commitment-title'), true);

        if ((!this.model.isNew() || this.checkFieldRequired('number')) && _.size(this.model.get('number')) === 0) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError(this.$('.commitment-number'), false);
        }

        if (!this.contractCompanyPicker.validate()) {
            isValid = false;
        }

        if (this.commitmentCustomFieldsForm != null && !this.commitmentCustomFieldsForm.validate())
            isValid = false;

        if (this.checkFieldRequired('invoiceContactId')) {
            if (!this.invoiceContactPicker.validate()) {
                isValid = false;
            }
        }

        if (this.checkFieldRequired('defaultWorkRetainagePercent')) {
            let $workRetainage = this.$('.default-work-retainage');
            PJQ.helpers.inputHelpers.setInputError($workRetainage, true);
            if (this.model.get('defaultWorkRetainagePercent') == null) {
                PJQ.helpers.inputHelpers.setInputError($workRetainage, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('defaultMaterialRetainagePercent')) {
            let $materialRetainage = this.$('.default-material-retainage');
            PJQ.helpers.inputHelpers.setInputError($materialRetainage, true);
            if (this.model.get('defaultMaterialRetainagePercent') == null) {
                PJQ.helpers.inputHelpers.setInputError($materialRetainage, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('termsId')) {
            let $terms = this.$('.select-terms');
            PJQ.helpers.inputHelpers.setInputError($terms, true);
            if (this.model.get('termsId') == null || this.model.get('termsId') === 0) {
                PJQ.helpers.inputHelpers.setInputError($terms, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('description')) {
            let $description = this.$('.commitment-description');
            PJQ.helpers.inputHelpers.setInputError($description, true);
            if (_.size(this.model.get('description')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($description, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('attachments')) {
            this.fileUploader.clearError();
            let hasValidAttachment = _.find(this.model.attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.fileUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('signedDocumentAttachments')) {
            this.signedDocumentUploader.clearError();
            let hasValidAttachment = _.find(this.model.signedDocumentAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.signedDocumentUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('affidavitAttachments')) {
            this.affidavitUploader.clearError();
            let hasValidAttachment = _.find(this.model.affidavitAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.affidavitUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('executedDocumentAttachments')) {
            this.executedDocumentUploader.clearError();
            let hasValidAttachment = _.find(this.model.executedDocumentAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.executedDocumentUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.model.get('commitmentType') === PJQ.constants.commitments.commitmentType.SUBCONTRACT) {
            if (this.checkFieldRequired('startDate')) {
                let $startDate = this.$('.start-date');
                PJQ.helpers.inputHelpers.setInputError($startDate, true);
                if (this.model.get('startDate') == null || this.model.get('startDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($startDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('estimatedCompletionDate')) {
                let $estimatedCompletionDate = this.$('.est-complete-date');
                PJQ.helpers.inputHelpers.setInputError($estimatedCompletionDate, true);
                if (this.model.get('estimatedCompletionDate') == null || this.model.get('estimatedCompletionDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($estimatedCompletionDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('actualCompletionDate')) {
                let $actualCompletionDate = this.$('.act-complete-date');
                PJQ.helpers.inputHelpers.setInputError($actualCompletionDate, true);
                if (this.model.get('actualCompletionDate') == null || this.model.get('actualCompletionDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($actualCompletionDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('contractDate')) {
                let $contractDate = this.$('.contract-date');
                PJQ.helpers.inputHelpers.setInputError($contractDate, true);
                if (this.model.get('contractDate') == null || this.model.get('contractDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($contractDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('signedContractReceivedDate')) {
                let $signedContractDate = this.$('.signed-contract-date');
                PJQ.helpers.inputHelpers.setInputError($signedContractDate, true);
                if (this.model.get('signedContractReceivedDate') == null || this.model.get('signedContractReceivedDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($signedContractDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('letterOfIntentDate')) {
                let $letterOfIntentDate = this.$('.letter-intent-date');
                PJQ.helpers.inputHelpers.setInputError($letterOfIntentDate, true);
                if (this.model.get('letterOfIntentDate') == null || this.model.get('letterOfIntentDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($letterOfIntentDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('approvalLetterDate')) {
                let $approvalLetterDate = this.$('.approval-letter-date');
                PJQ.helpers.inputHelpers.setInputError($approvalLetterDate, true);
                if (this.model.get('approvalLetterDate') == null || this.model.get('approvalLetterDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($approvalLetterDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('issuedOnDate')) {
                let $issuedOnDate = this.$('.issued-date');
                PJQ.helpers.inputHelpers.setInputError($issuedOnDate, true);
                if (this.model.get('issuedOnDate') == null || this.model.get('issuedOnDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($issuedOnDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('executionDate')) {
                let $executedOnDate = this.$('.execution-date');
                PJQ.helpers.inputHelpers.setInputError($executedOnDate, true);
                if (this.model.get('executionDate') == null || this.model.get('executionDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($executedOnDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('returnedDate')) {
                let $returnedOnDate = this.$('.returned-date');
                PJQ.helpers.inputHelpers.setInputError($returnedOnDate, true);
                if (this.model.get('returnedDate') == null || this.model.get('returnedDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($returnedOnDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('inclusions')) {
                let $inclusions = this.$('.inclusions');
                PJQ.helpers.inputHelpers.setInputError($inclusions, true);
                if (_.size(this.model.get('inclusions')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($inclusions, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('exclusions')) {
                let $exclusions = this.$('.exclusions');
                PJQ.helpers.inputHelpers.setInputError($exclusions, true);
                if (_.size(this.model.get('exclusions')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($exclusions, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('coiAttachments')) {
                this.coiUploader.clearError();
                let hasValidAttachment = _.find(this.model.coiAttachments.models, function (model) {
                    return !model.get('delete')
                }, this) != null;

                if (!hasValidAttachment) {
                    this.coiUploader.showError('Missing attachment', 100000);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('w9Attachments')) {
                this.w9Uploader.clearError();
                let hasValidAttachment = _.find(this.model.w9Attachments.models, function (model) {
                    return !model.get('delete')
                }, this) != null;

                if (!hasValidAttachment) {
                    this.w9Uploader.showError('Missing attachment', 100000);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('lienWaiverAttachments')) {
                this.lienWaiverUploader.clearError();
                let hasValidAttachment = _.find(this.model.lienWaiverAttachments.models, function (model) {
                    return !model.get('delete')
                }, this) != null;

                if (!hasValidAttachment) {
                    this.lienWaiverUploader.showError('Missing attachment', 100000);
                    isValid = false;
                }
            }
        } else {
            if (this.checkFieldRequired('deliveryDate')) {
                let $deliveryDate = this.$('.delivery-date');
                PJQ.helpers.inputHelpers.setInputError($deliveryDate, true);
                if (this.model.get('deliveryDate') == null || this.model.get('deliveryDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($deliveryDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('paymentTerms')) {
                let $paymentTerms = this.$('.payment-terms');
                PJQ.helpers.inputHelpers.setInputError($paymentTerms, true);
                if (_.size(this.model.get('paymentTerms')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($paymentTerms, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('shipVia')) {
                let $shipVia = this.$('.ship-via');
                PJQ.helpers.inputHelpers.setInputError($shipVia, true);
                if (_.size(this.model.get('shipVia')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($shipVia, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('shipToId')) {
                let $shipToCompany = this.$('.shipto-companyname'),
                    $shipToContact = this.$('.shipto-contactname'),
                    $shipToAddress1 = this.$('.shipto-address1'),
                    $shipToCity = this.$('.shipto-city'),
                    $shipToZip = this.$('.shipto-zip');
                PJQ.helpers.inputHelpers.setInputError($shipToCompany, true);
                PJQ.helpers.inputHelpers.setInputError($shipToContact, true);
                PJQ.helpers.inputHelpers.setInputError($shipToAddress1, true);
                PJQ.helpers.inputHelpers.setInputError($shipToCity, true);
                PJQ.helpers.inputHelpers.setInputError($shipToZip, true);

                if (_.size(this.model.get('shipTo').companyName) === 0 ||
                    _.size(this.model.get('shipTo').contactName) === 0 ||
                    _.size(this.model.get('shipTo').address1) === 0 ||
                    _.size(this.model.get('shipTo').city) === 0 ||
                    _.size(this.model.get('shipTo').zip) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($shipToCompany, _.size(this.model.get('shipTo').companyName) > 0);
                    PJQ.helpers.inputHelpers.setInputError($shipToContact, _.size(this.model.get('shipTo').contactName) > 0);
                    PJQ.helpers.inputHelpers.setInputError($shipToAddress1, _.size(this.model.get('shipTo').address1) > 0);
                    PJQ.helpers.inputHelpers.setInputError($shipToCity, _.size(this.model.get('shipTo').city) > 0);
                    PJQ.helpers.inputHelpers.setInputError($shipToZip, _.size(this.model.get('shipTo').zip) > 0);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('billToId')) {
                let $billToCompany = this.$('.billto-companyname'),
                    $billToContact = this.$('.billto-contactname'),
                    $billToAddress1 = this.$('.billto-address1'),
                    $billToCity = this.$('.billto-city'),
                    $billToZip = this.$('.billto-zip');
                PJQ.helpers.inputHelpers.setInputError($billToCompany, true);
                PJQ.helpers.inputHelpers.setInputError($billToContact, true);
                PJQ.helpers.inputHelpers.setInputError($billToAddress1, true);
                PJQ.helpers.inputHelpers.setInputError($billToCity, true);
                PJQ.helpers.inputHelpers.setInputError($billToZip, true);

                if (_.size(this.model.get('billTo').companyName) === 0 ||
                    _.size(this.model.get('billTo').contactName) === 0 ||
                    _.size(this.model.get('billTo').address1) === 0 ||
                    _.size(this.model.get('billTo').city) === 0 ||
                    _.size(this.model.get('billTo').zip) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($billToCompany, _.size(this.model.get('billTo').companyName) > 0);
                    PJQ.helpers.inputHelpers.setInputError($billToContact, _.size(this.model.get('billTo').contactName) > 0);
                    PJQ.helpers.inputHelpers.setInputError($billToAddress1, _.size(this.model.get('billTo').address1) > 0);
                    PJQ.helpers.inputHelpers.setInputError($billToCity, _.size(this.model.get('billTo').city) > 0);
                    PJQ.helpers.inputHelpers.setInputError($billToZip, _.size(this.model.get('billTo').zip) > 0);
                    isValid = false;
                }
            }
        }

        if (!isValid) {
            this.activateView(this.views.GENERAL);
            return isValid;
        }

        if (!this.lineItemsView.validate()) {
            isValid = false;
            this.activateView(this.views.LINEITEMS);
            return isValid;
        }

        return isValid;
    },
    save: function (callback) {
        if (this.model.get('commitmentType') === PJQ.constants.commitments.commitmentType.PURCHASE_ORDER && this.options.canEdit) {
            let billTo = this.model.get('billTo') ? this.model.get('billTo') : {};
            billTo.companyName = this.$('.billto-companyname').val();
            billTo.contactName = this.$('.billto-contactname').val();
            billTo.address1 = this.$('.billto-address1').val();
            billTo.address2 = this.$('.billto-address2').val();
            billTo.city = this.$('.billto-city').val();
            billTo.zip = this.$('.billto-zip').val();
            billTo.phone = PJQ.helpers.formatHelpers.numbersOnly(this.$('.billto-phone').val());
            billTo.fax = PJQ.helpers.formatHelpers.numbersOnly(this.$('.billto-fax').val());
            billTo.email = this.$('.billto-email').val();
            this.model.set('billTo', billTo);

            let shipTo = this.model.get('shipTo') ? this.model.get('shipTo') : {};
            shipTo.companyName = this.$('.shipto-companyname').val();
            shipTo.contactName = this.$('.shipto-contactname').val();
            shipTo.address1 = this.$('.shipto-address1').val();
            shipTo.address2 = this.$('.shipto-address2').val();
            shipTo.city = this.$('.shipto-city').val();
            shipTo.zip = this.$('.shipto-zip').val();
            shipTo.phone = PJQ.helpers.formatHelpers.numbersOnly(this.$('.shipto-phone').val());
            shipTo.fax = PJQ.helpers.formatHelpers.numbersOnly(this.$('.shipto-fax').val());
            shipTo.email = this.$('.shipto-email').val();
            this.model.set('shipTo', shipTo);
        }

        if (!this.validate()) {
            this.$('.modal').prevObject.scrollTop(0);
            if (typeof callback === 'function') {
                callback(false);
            }
            return;
        }

        this.model.set('customFields', this.commitmentCustomFieldsForm != null ? this.commitmentCustomFieldsForm.getChanged() : null);

        this.model.save({
            assignedTo: this.assignedTo,
            invoiceContact: this.invoiceContact,
            lineItems: this.model.lineItems.models
        }, {
            success: () => {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.options.project.trigger('commitmentChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            },
            error: (data) => {
                if (typeof callback === 'function') {
                    callback(false);
                }
                PJQ.notifications.notify.errorNotify({
                    message: data.responseJSON.error
                });
            }
        });

        return true;
    },
    deleteCommitment: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this commitment?  All associated change orders and invoices will also be deleted.",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Commitment deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete();

                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    saveEmail: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Commitment saved successfully'
                });
                this.email();
            }
        });
    },
    saveCommitment: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Commitment saved successfully'
                });

                this.removeModal();
            }
        });
    },
    validateForSubmit: function () {
        let isValid = true,
            scrollEl = null;
        if (this.model.get('isCOIRequiredForSubmit')) {
            this.coiUploader.clearError();
            let hasValidAttachment = _.find(this.model.coiAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.coiUploader.showError('Missing attachment', 100000);
                isValid = false;

                scrollEl = scrollEl || this.coiUploader.$el[0];
            }
        }

        if (this.model.get('isW9RequiredForSubmit')) {
            this.w9Uploader.clearError();
            let hasValidAttachment = _.find(this.model.w9Attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.w9Uploader.showError('Missing attachment', 100000);
                isValid = false;

                scrollEl = scrollEl || this.w9Uploader.$el[0];
            }
        }

        if (this.model.get('isLienWaiverRequiredForSubmit')) {
            this.lienWaiverUploader.clearError();
            let hasValidAttachment = _.find(this.model.lienWaiverAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.lienWaiverUploader.showError('Missing attachment', 100000);
                isValid = false;

                scrollEl = scrollEl || this.lienWaiverUploader.$el[0];
            }
        }

        if (this.model.get('isSignedDocumentsRequiredForSubmit')) {
            this.signedDocumentUploader.clearError();
            let hasValidAttachment = _.find(this.model.signedDocumentAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.signedDocumentUploader.showError('Missing attachment', 100000);
                isValid = false;

                scrollEl = scrollEl || this.signedDocumentUploader.$el[0];
            }
        }

        if (this.model.get('isAffidavitRequiredForSubmit')) {
            this.affidavitUploader.clearError();
            let hasValidAttachment = _.find(this.model.affidavitAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.affidavitUploader.showError('Missing attachment', 100000);
                isValid = false;

                scrollEl = scrollEl || this.affidavitUploader.$el[0];
            }
        }

        if (scrollEl != null && typeof scrollEl.scrollIntoView === 'function') {
            scrollEl.scrollIntoView();
        }

        return isValid;
    },
    submitForReview: function () {
        if (!this.validateForSubmit()) {
            return;
        }

        this.model.submit((result) => {
            if (result) {
                this.options.project.trigger('commitmentChanged', this.model);

                PJQ.notifications.notify.successNotify({
                    message: 'Commitment submitted successfully'
                });

                this.removeModal();
            }
        });
    },
    signAndSubmit: function () {
        if (!this.validateForSubmit()) {
            return;
        }

        new PJQ.views.signatures.SignatureSubmitModal({
            onSubmit: (signature, callback) => {
                this.model.set('signature', signature);
                this.model.submit(() => {
                    this.options.project.trigger('commitmentChanged', this.model);

                    this.render();
                    callback();

                    PJQ.notifications.notify.successNotify({
                        message: 'Commitment signed & submitted successfully'
                    });
                });
            }
        });
    },
    email: function () {
        let subjectTmpl = this.settings.get('defaultEmailSubject');
        if (_.size(subjectTmpl) === 0) {
            subjectTmpl = `A Commitment has been shared with you for [project.projectName]`;
        }
        new PJQ.views.email.ComposeEmailModal({
            project: PJQ.app.session.project,
            header: "Email Commitment",
            subjectTemplate: subjectTmpl,
            tokens: {
                project: PJQ.app.session.project.attributes,
                commitment: this.model.attributes
            },
            onSave: (data) => {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Commitment email sent'
                    });
                }, this));
            }
        });
    },
    renderMarkups: function () {
        if (!this.options.isAdmin) {
            return;
        }

        this.markupsView = new PJQ.financialMarkups.views.FinancialMarkupsList({
            el: this.$('.c-markups'),
            collection: this.model.markupItems,
            canEdit: this.options.canEditLineItems,
            canVoid: true,
            defaultToAppliedMarkups: this.settings.get('defaultToAppliedMarkups'),
        });
    },
    renderERP: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || !this.options.project.isERPSynced()
            || false === this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_COMMITMENTS)) {
            $erp.remove();
            return;
        }

        this.$('.erp-badge').html(PJQ.helpers.erp.getERPBadge(this.model.erpSyncStatus(), this.model.get('externalObject')));

        let hasUnreleasedRetainage = null != _.find(this.model.invoices.models, (invoice) => {
                return invoice.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.SYNCED
                    && invoice.get('workRetainage') > 0;
            }),
            canPush = true,
            disablePushReason = "",
            fnRenderButtons = _.bind(function () {
                PJQ.helpers.erp.renderERPButtons($erp, {
                    status: this.model.erpSyncStatus(),
                    canReleaseRetainage: hasUnreleasedRetainage && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.CAN_RELEASE_COMMITMENT_RETAINAGE, this.model),
                    pushSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COMMITMENTS),
                    canPush: canPush,
                    canPushChanges: false,
                    disablePushReason: disablePushReason,
                    unlinkSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_COMMITMENTS),
                });
            }, this);

        if (_.size(this.model.lineItems.models) === 0
            || (this.model.get('statusId') !== PJQ.constants.commitments.commitmentStatus.APPROVED
                && this.model.get('statusId') !== PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_COMPLETE
                && this.model.get('statusId') !== PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_CLOSED)) {
            canPush = false;
            disablePushReason = "Commitment must be approved or complete and have line items";
        }

        let canPushWithoutVendorSynced = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COMMITMENTS_WITH_VENDOR);
        if (this.model.contractedContact && !canPushWithoutVendorSynced) {
            this.model.contractedContact.fetchCompanyERPObject(_.bind(function (erpObject) {
                if (!erpObject || _.size(erpObject.externalId) === 0) {
                    canPush = false;
                    disablePushReason = "Contracted Company must be synced to ERP before this commitment can be pushed";
                }
                fnRenderButtons();
            }, this));
        } else {
            fnRenderButtons();
        }
    },
    releaseERPRetainage: function () {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.CAN_RELEASE_COMMITMENT_RETAINAGE, this.model)) {
            return;
        }

        this.erpIntegration.releaseCommitmentRetainage(this.model, _.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: "Retainage Release for this Commitment's invoices pushed to ERP"
            });

            if (typeof this.options.onSave === 'function') {
                this.options.onSave(this.model);
            }

            if (typeof callback === 'function') {
                callback();
            } else {
                this.render();
            }
        }, this));
    },
    pushERP: function (callback) {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COMMITMENTS)) {
            return;
        }

        this.save((success) => {
            if (success) {
                this.erpIntegration.pushCommitment(this.model, () => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Commitment pushed to ERP'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    if (callback && typeof callback === 'function') {
                        callback();
                    } else {
                        this.render();
                    }
                });
            }
        });
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.model, () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Commitment removed from ERP approval'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.render();
            });
        }
    },
    unlinkERP: function () {
        new PJQ.views.modals.YesNo({
            header: "Unlink from ERP",
            body: "Are you sure you want to unlink this Commitment from your ERP system?  This will also unlink all Change Orders and Invoices associated with it.",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                this.erpIntegration.unlinkCommitment(this.model, (success) => {
                    if (success) {
                        loader.remove();
                        PJQ.notifications.notify.successNotify({
                            message: 'Commitment unlinked from ERP'
                        });

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }

                        this.render();
                    }
                });
            }
        });
    },
    viewHistory: async function () {
        let cType = PJQ.constants.commitments.commitmentTypeNames[this.model.get('commitmentType')],
            historyItems = [{
                date: this.model.get('createdOn'),
                person: this.model.get('createdBy'),
                action: cType + ' Created'
            }];

        let history = new PJQ.collections.commitments.History({}, {
            commitmentId: this.model.id
        });
        new PJQ.views.history.HistoryTimelineModal({
            collection: history,
            subTitle: cType + ' #' + this.model.get('number'),
            items: historyItems
        });
    },
    exportCommitment: function () {
        let callback = () => {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'commitments',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ]), {isAPIv2: true});
        };
        if (this.options.canEdit && this.model.hasChanged()) {
            this.save(callback);
        } else {
            callback();
        }
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveCommitment();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});
PJQ.views.commitments.CommitmentsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'commitments-list'),
        commitmentId: null
    },
    events: {
        'click .btn-settings': 'editSettings',
        'click .new-po': 'newCommitment',
        'click .new-subcontract': 'newCommitment',
        'click .btn-view-commitment': 'viewCommitmentClicked',
        'click .btn-delete-commitment': 'deleteCommitmentClicked',
        'click .btn-export': 'exportList',
        'click .btn-pull-erp': 'pullERP',
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.commitments.Commitments(null, {
                projectId: this.options.project.get('projectId'),
                costCodeId: this.options.costCodeId ? this.options.costCodeId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }
        this.settings = await this.options.project.fetchCommitmentSettings();

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.userSettings = await PJQ.app.session.fetchCommitmentUserSettings();
        this.customFields = await this.options.project.fetchCommitmentCustomFields();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canEdit = this.options.project.hasPermission('commitments.canEdit');
        this.options.isChangeOrdersAdmin = this.options.project.hasPermission('commitmentChangeOrders.isAdmin');
        this.options.isAdmin = this.options.project.hasPermission('commitments.isAdmin');
    },
    renderData: function () {
        return {
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        PJQ.app.session.project.off('commitmentChanged');
        PJQ.app.session.project.on('commitmentChanged', function (commitment) {
            this.collection.add(commitment);
            this.render();
        }, this);

        if (this.options.commitmentId > 0) {
            let initCommitment = this.collection.get(this.options.commitmentId);
            if (initCommitment != null) {
                this.viewCommitment(initCommitment);
                this.options.commitmentId = null;
            }
        }
    },
    renderERPButton: function () {
        let $erp = this.$('.erp-sync')
        if (!this.options.isAdmin || this.erpIntegration == null || !this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_COMMITMENTS) || !this.options.project || !this.options.project.isERPSynced()) {
            $erp.remove();
            return;
        }

        let pullSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMMITMENTS);
        if(pullSupported && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMMITMENTS_DOC_CLERK_REQUIRED) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK)){
            pullSupported = false;
        }

        PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: false,
            pullSupported: pullSupported
        });
    },
    pullERP: function () {
        if (this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMMITMENTS)) {
            this.erpIntegration.pullCommitments(this.options.project, _.bind(function (res) {
                PJQ.notifications.notify.successNotify({
                    message: 'Commitments successfully pulled from ERP'
                });

                this.collection.reset(res);
                this.render();
            }, this));
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.commitments.CommitmentDataTable({
            el: this.$('.commitments-data'),
            rowId: "cid",
            data: this.collection.models,
            onPageSizeChange: function (value) {
                // PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.RFI_PAGE_LENGTH, value);
            },
            isAdmin: this.options.isAdmin,
            statusIds: this.options.statusIds,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    canAdd: this.options.canEdit,
                    isAdmin: this.options.isAdmin,
                    settings: this.settings
                };
            }, this),
            enableColumnResize: true,
            groups: this.groups,
            costTypes: this.costTypes,
            columnWidthCookie: PJQ.constants.cookies.COMMITMENT_LIST_COLUMNS_WIDTH,
            unitsOfMeasure: this.unitsOfMeasure,
            userSettings: this.userSettings,
            settings: this.userSettings.getSettings(PJQ.constants.commitments.view.COMMITMENTS),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsLeft: 1,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                this.userSettings.save();
            }, this),
            onRowDoubleClick: _.bind(function (row) {
                this.viewCommitment(row.data());
            }, this),
            afterDataTableRender: _.bind(function () {
                if (PJQ.app.session.erpIntegration && PJQ.app.session.erpIntegration.id > 0) {
                    this.renderERPButton();
                }
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewCommitment(row.data());
                        }, this)
                    },
                    {
                        name: 'New Change Order',
                        isShown: _.bind(function (row) {
                            let status = row.data().get('statusId');
                            return this.options.isAdmin && this.options.isChangeOrdersAdmin && status !== PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_TERMINATED && status !== PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_CLOSED;
                        }, this),
                        onClick: _.bind(function (row) {
                            new PJQ.views.commitments.ChangeOrderEditModal({
                                commitment: row.data()
                            });
                        }, this)
                    }
                ]
            }
        });
    },
    exportList: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            }
        ]), {isAPIv2: true});
    },
    editSettings: function () {
        new PJQ.views.commitments.CommitmentSettingsModal({
            commitmentsView: this,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    },
    newCommitment: function (e) {
        let commitmentType = $(e.currentTarget).hasClass('new-po') ? PJQ.constants.commitments.commitmentType.PURCHASE_ORDER : PJQ.constants.commitments.commitmentType.SUBCONTRACT;
        this.viewCommitment(null, commitmentType);
    },
    viewCommitmentClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        if (row != null) {
            this.viewCommitment(row.data());
        }
    },
    viewCommitment: function (commitment, commitmentType) {
        let isNew = commitment == null
        new PJQ.views.commitments.CommitmentEditModal({
            model: commitment,
            commitmentType: commitmentType,
            onChangeOrderAdd: _.bind(function (changeOrder) {
                if (typeof this.options.onChangeOrderAdd === 'function') {
                    this.options.onChangeOrderAdd(changeOrder);
                }
            }, this),
            onChangeOrderDelete: _.bind(function (changeOrderId) {
                if (typeof this.options.onChangeOrderDelete === 'function') {
                    this.options.onChangeOrderDelete(changeOrderId);
                }
            }, this),
            onInvoiceAdd: _.bind(function (invoice) {
                if (typeof this.options.onChangeOrderAdd === 'function') {
                    this.options.onInvoiceAdd(invoice);
                }
            }, this),
            onSave: _.bind(function (commitment) {
                if (isNew) {
                    this.collection.add(commitment);
                }
                this.renderView();

                if (typeof this.options.onCommitmentSave === 'function') {
                    this.options.onCommitmentSave(commitment);
                }
            }, this),
            onDelete: _.bind(function (commitment) {
                this.collection.remove(commitment);
                this.renderView();

                if (typeof this.options.onCommitmentDelete === 'function') {
                    this.options.onCommitmentDelete(commitment);
                }
            }, this)
        })
    },
    deleteCommitmentClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteCommitment(row);
    },
    deleteCommitment: function (row) {
        if (row != null) {
            let commitment = row.data();
            if (commitment != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Commitment",
                    body: "Are you sure you want to delete this Commitment?",
                    onDelete: _.bind(function () {
                        commitment.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(commitment);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    }
});

PJQ.views.commitments.ModalViewCommitments = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'modal-view-change-orders'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {},
    beforeModalCreated: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model != null) {
            new PJQ.views.commitments.CommitmentsList({
                el: this.$('.modal-body'),
                model: this.model,
                costCodeId: this.model.get('costCodeId'),
                costTypeId: this.model.get('costTypeId'),
                statusIds: this.options.statusIds,
                project: this.options.project
            })
        }
    },
});

PJQ.views.commitments.SelectCommitmentsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'modal-select-commitments'),
        width: '60%',
        maxWidth: 700,
        onSave: _.noop,
        selectedCommitmentId: null,
        headerSubText: null
    },
    events: {
        "change .select-commitment": "selectCommitment",
        "click .btn-save": "save",
        "click .btn-cancel": "cancel"
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.options.isAdmin = PJQ.app.session.project.hasPermission('commitments.isAdmin');

        this.selectedCommitment = null;
        this.selectedCommitments = [];

        if (this.collection == null) {
            this.collection = new PJQ.collections.commitments.Commitments(null, {
                projectId: this.options.project.get('projectId')
            });
        }

        await this.collection.fetch();

        if (this.options.selectedCommitmentId != null) {
            this.selectedCommitment = this.collection.get(this.options.selectedCommitmentId);
        }

        if (this.options.filterStatuses) {
            this.collection.models = _.filter(this.collection.models, function (model) {
                let statusId = model.get('statusId');

                if (_.isArray(this.options.filterStatuses)) {
                    return _.includes(this.options.filterStatuses, statusId);
                } else if (_.isNumber(this.options.filterStatuses)) {
                    return this.options.filterStatuses === statusId;
                }

                return false;

            }, this);
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            headerSubText: this.options.headerSubText,
            isSingleChoice: this.options.isSingleChoice,
            hasSelected: this.options.isSingleChoice ? this.selectedCommitment != null : _.size(this.selectedCommitments) > 0
        }
    },
    isSelected: function (commitment) {
        if (this.options.isSingleChoice) {
            return this.selectedCommitment != null && this.selectedCommitment.cid === commitment.cid;
        }
        return this.selectedCommitments != null && this.selectedCommitments.indexOf(commitment.cid);
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.commitments-table'),
            data: this.collection.models,
            isHideSearch: true,
            order: [],
            columns: [{
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": (data, type, row) => {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (this.isSelected(row) ? 'checked' : '') + ' class="select-commitment"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }
            },
                {
                    "data": "attributes.number",
                    "title": "Number",
                    "orderable": true
                },
                {
                    "data": "attributes.commitmentType",
                    "title": "Type",
                    "width": "110px",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.commitments.commitmentTypeNames[row.get('commitmentType')]
                    }, this)
                },
                {
                    "columnData": "attributes.contractedContact.companyName",
                    "title": "Company",
                    "titleSettings": "Contracted Company",
                    "render": _.bind(function (data, type, row) {
                        return row.get('contractedContact') ? row.get('contractedContact').companyName : 'N/A';
                    }, this)
                },
                {
                    "data": "attributes.description",
                    "title": "Description",
                    "orderable": false
                },
                {
                    "data": "attributes.amount",
                    "title": "Grand Total",
                    "orderable": false,
                    "className": "text-align-right",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    selectCommitment: function (e) {
        let target = $(e.currentTarget),
            commitment = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-commitment').not(target).text('Select').prop('checked', false);
            if (commitment.get('isSelected')) {
                commitment.set('isSelected', false);
                this.selectedCommitment = null;
            } else {
                commitment.set('isSelected', true);
                this.selectedCommitment = commitment;
                this.collection.get(commitment.id);
                _.each(this.collection.models, _.bind(function (dtCommitment) {
                    if (commitment.id !== dtCommitment.id)
                        dtCommitment.set('isSelected', false);
                }, this));
            }
            this.$('.btn-save').attr('disabled', this.selectedCommitment == null);

            if (typeof this.options.onCommitmentSelected === 'function') {
                this.options.onCommitmentSelected(this.selectedCommitment);
            }
        } else {
            if (commitment.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                commitment.set('isSelected', false);
                this.selectedCommitments = _.reject(this.selectedCommitments, function (selCommitment) {
                    return selCommitment.id === commitment.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                commitment.set('isSelected', true);
                this.selectedCommitments.push(commitment);
            }
            this.$('.btn-save').attr('disabled', this.selectedCommitments == null);

            if (typeof this.options.onCommitmentSelected === 'function') {
                this.options.onCommitmentSelected(this.selectedCommitments);
            }
        }
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    save: function () {
        if (this.options.onSave) {
            this.options.onSave(this.selectedCommitment ? this.selectedCommitment : this.selectedCommitments);
            this.removeModal();
        }
    }
});
PJQ.views.commitments.CommitmentManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'commitment-management'),
        subTemplates: {
            commitmentTotals: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'commitment-management-totals'),
            invoiceTotals: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'invoicing-management-totals')
        },
        commitmentId: null,
        changeOrderId: null,
        invoiceId: null,
        view: null
    },
    events: {
        'shown.bs.tab .nav-tabs': 'tabActivated',
        'click .btn-settings': 'settings'
    },
    beforeFirstRender: function () {
        this.options.canViewCommitments = PJQ.app.session.project.hasPermission('commitments.canView');
        this.options.canViewChangeOrders = PJQ.app.session.project.hasPermission('commitmentChangeOrders.canView');
        this.options.canViewInvoices = PJQ.app.session.project.hasPermission('payableInvoices.canView');
        this.options.isAdmin = PJQ.app.session.project.hasPermission('commitments.isAdmin')
            && PJQ.app.session.project.hasPermission('commitmentChangeOrders.isAdmin')
            && PJQ.app.session.project.hasPermission('payableInvoices.isAdmin');
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            commitments: this.commitments,
            changeOrders: this.changeOrders,
            invoices: this.invoices,
            canViewCommitments: this.options.canViewCommitments,
            canViewChangeOrders: this.options.canViewChangeOrders,
            canViewInvoices: this.options.canViewInvoices,
            isAdmin: this.options.isAdmin
        }
    },
    afterRender: function () {
        this.commitmentsView = null;
        this.changeOrdersView = null;
        this.invoicesView = null;

        if (this.options.view != null) {
            this.activateTab(this.options.view);
        } else if (this.options.commitmentId > 0 && this.options.canViewCommitments) {
            this.activateTab('commitments');
        } else if (this.options.changeOrderId > 0 && this.options.canViewChangeOrders) {
            this.activateTab('changeorders');
        } else if (this.options.invoiceId > 0 && this.options.canViewInvoices) {
            this.activateTab('invoices');
        } else if (this.options.canViewCommitments) {
            this.activateTab('commitments');
        } else if (this.options.canViewChangeOrders) {
            this.activateTab('changeorders');
        } else if (this.options.canViewInvoices) {
            this.activateTab('invoices');
        }
    },
    renderStats: function () {
        let totals,
            $totals = this.$('.totals-outer');
        switch (this.activeView) {
            case 'changeorders':
                if (this.changeOrdersView == null || this.changeOrdersView.collection == null || !this.changeOrdersView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.changeOrdersView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.commitmentTotals, $totals, {
                    pending: totals[PJQ.constants.commitments.changeOrderStatusBuckets.PENDING.name],
                    projected: totals[PJQ.constants.commitments.changeOrderStatusBuckets.PROJECTED.name],
                    committed: totals[PJQ.constants.commitments.changeOrderStatusBuckets.COMMITTED.name]
                });
                break;
            case 'invoices':
                if (this.invoicesView == null || this.invoicesView.collection == null || !this.invoicesView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.invoicesView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.invoiceTotals, $totals, {
                    draft: totals[PJQ.constants.invoicing.payableInvoiceStatus.DRAFT],
                    reviewing: totals[PJQ.constants.invoicing.payableInvoiceStatus.REVIEWING],
                    approved: totals[PJQ.constants.invoicing.payableInvoiceStatus.APPROVED],
                    complete: totals[PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE],
                    revise: totals[PJQ.constants.invoicing.payableInvoiceStatus.REVISE]
                });
                break;
            default:
                if (this.commitmentsView == null || this.commitmentsView.collection == null || !this.commitmentsView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.commitmentsView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.commitmentTotals, $totals, {
                    pending: totals[PJQ.constants.commitments.commitmentStatusBuckets.PENDING.name],
                    projected: totals[PJQ.constants.commitments.commitmentStatusBuckets.PROJECTED.name],
                    committed: totals[PJQ.constants.commitments.commitmentStatusBuckets.COMMITTED.name]
                });
                break;
        }
    },
    activateTab: function (tab) {
        this.activeView = tab;
        switch (tab ? tab.toLowerCase() : null) {
            case 'changeorders':
                tab = 'CCO_List';
                this.renderChangeOrdersView();
                break;
            case 'invoices':
                tab = 'PI_List';
                this.renderInvoicesView();
                break;
            default:
                tab = 'C_List';
                this.renderCommitmentsView();
                break;
        }

        this.isActivating = true;
        this.$('.nav-link[href="#' + tab + '"]').tab('show');
        this.isActivating = false;

        this.renderStats();
    },
    tabActivated: function (e) {
        if(this.isActivating){
            return;
        }

        this.activeTab = $(e.target).attr('href');

        let vw;
        switch (this.activeTab) {
            case '#C_List':
                vw = 'commitments';
                break;
            case '#CCO_List':
                vw = 'changeorders';
                break;
            case '#PI_List':
                vw = 'invoices';
                break;
        }
        this.activateTab(vw);
    },
    renderCommitmentsView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/commitments', {
            trigger: false
        });
        if (this.commitmentsView == null && this.options.canViewCommitments) {
            let fnRender = _.bind(function () {
                this.commitmentsView = new PJQ.views.commitments.CommitmentsList({
                    el: this.$('.commitments-pane'),
                    project: PJQ.app.session.project,
                    commitmentId: this.options.commitmentId,
                    collection: this.commitments,
                    afterRender: _.bind(this.renderStats, this),
                    onCommitmentSave: _.bind(function () {
                        this.renderStats();
                    }, this),
                    onCommitmentDelete: _.bind(function () {
                        this.renderStats();
                    }, this),
                    onChangeOrderAdd: _.bind(function (changeOrder) {
                        if (this.changeOrders != null) {
                            this.changeOrders.add(changeOrder);

                            if (this.changeOrdersView != null) {
                                this.changeOrdersView.render();
                            }
                        }
                        this.renderStats();
                    }, this),
                    onChangeOrderDelete: _.bind(function (changeOrderId) {
                        if (this.changeOrders) {
                            let changeOrder = this.changeOrders.get(changeOrderId);
                            this.changeOrders.remove(changeOrder);

                            if (this.changeOrdersView != null) {
                                this.changeOrdersView.render();
                            }
                            this.renderStats();
                        }
                    }, this),
                    onInvoiceAdd: _.bind(function (invoice) {
                        if (this.invoices != null) {
                            this.invoices.add(invoice);

                            if (this.invoicesView != null) {
                                this.invoicesView.render();
                            }
                        }
                    }, this)
                });
                this.options.commitmentId = null;
            }, this)

            if (this.commitments == null) {
                this.commitments = new PJQ.collections.commitments.Commitments(null, {
                    projectId: this.options.project.get('projectId')
                });
                this.commitments.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                });
            } else {
                fnRender();
            }
        }
    },
    renderChangeOrdersView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/commitments/changeorders', {
            trigger: false
        });
        if (this.changeOrdersView == null && this.options.canViewChangeOrders) {
            let fnRender = _.bind(function () {
                this.changeOrdersView = new PJQ.views.commitments.ChangeOrdersList({
                    el: this.$('.change-orders-pane'),
                    project: PJQ.app.session.project,
                    changeOrderId: this.options.changeOrderId,
                    collection: this.changeOrders,
                    afterRender: _.bind(this.renderStats, this),
                });
                this.options.changeOrderId = null;
            }, this)

            if (this.changeOrders == null) {
                this.changeOrders = new PJQ.collections.commitments.ChangeOrders(null, {
                    projectId: this.options.project.get('projectId')
                });
                this.changeOrders.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                });
            } else {
                fnRender();
            }
        }
    },
    renderInvoicesView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/commitments/invoices', {
            trigger: false
        });
        if (this.invoicesView == null && this.options.canViewInvoices) {
            let fnRender = _.bind(function () {
                this.invoicesView = new PJQ.views.invoicing.PayableInvoicesList({
                    el: this.$('.invoices-pane'),
                    project: PJQ.app.session.project,
                    invoiceId: this.options.invoiceId,
                    inviteResponse: this.options.inviteResponse,
                    collection: this.invoices,
                    afterRender: _.bind(this.renderStats, this),
                    onDelete: _.bind(function (invoice) {
                        this.invoices.remove(invoice);
                    }, this)
                });
                this.options.invoiceId = null;
            }, this)

            if (this.invoices == null) {
                this.invoices = new PJQ.collections.invoicing.PayableInvoices(null, {
                    project: this.options.project
                });
                this.invoices.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                })
            } else {
                fnRender();
            }
        }
    },
    getActiveTab: function () {
        return this.$('.nav-item>.nav-link.active').attr('href');
    },
    settings: function () {
        switch (this.getActiveTab()) {
            case '#C_List':
                if (this.commitmentsView != null) {
                    this.commitmentsView.editSettings();
                }
                break;
            case '#CCO_List':
                if (this.changeOrdersView != null) {
                    this.changeOrdersView.editSettings();
                }
                break;
            case '#PI_List':
                if (this.invoicesView != null) {
                    this.invoicesView.editSettings();
                }
                break;
        }
    },
    updateTotalsCount: function () {
        let $commitmentSpan = this.$('.commitments-total'),
            $changeOrdersSpan = this.$('.change-orders-total'),
            $invoicesSpan = this.$('.invoices-total');
        $commitmentSpan.text(_.size(this.commitments.models));
        $changeOrdersSpan.text(_.size(this.changeOrders.models));
        $invoicesSpan.text(_.size(this.invoices.models));
    }
});
PJQ.models.commitments.Commitment = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        arr.push({
            endpoint: 'commitments',
            value: this.id
        });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.commitments.CommitmentAttachments(model.attachments);
        this.w9Attachments = new PJQ.collections.commitments.CommitmentAttachments(model.w9Attachments);
        this.coiAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.coiAttachments);
        this.lienWaiverAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.lienWaiverAttachments);
        this.signedDocumentAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.signedDocumentAttachments);
        this.affidavitAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.affidavitAttachments);
        this.executedDocumentAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.executedDocumentAttachments);
        this.customFieldAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.customFieldAttachments);

        this.lineItems = new PJQ.collections.commitments.CommitmentLineItems(model ? model.lineItems : null);
        this.changeOrders = new PJQ.collections.commitments.ChangeOrders(model ? model.changeOrders : null);
        this.invoices = new PJQ.collections.invoicing.PayableInvoices(model ? model.invoices : null);
        this.payments = new PJQ.collections.invoicing.PayableInvoicePayments(model.payments);

        this.markupItems = new PJQ.financialMarkups.collections.FinancialMarkups(model ? model.markupItems : null);

        if (model.contractedContact) {
            if (model.contractedContact instanceof PJQ.models.BaseModel) {
                this.contractedContact = model.contractedContact;
            } else {
                this.contractedContact = new PJQ.models.contacts.Contact(model.contractedContact);
            }
        }

        if (model.invoiceContact) {
            if (model.invoiceContact instanceof PJQ.models.BaseModel) {
                this.invoiceContact = model.invoiceContact;
            } else {
                this.invoiceContact = new PJQ.models.contacts.Contact(model.invoiceContact);
            }
        }

        return model;
    },
    beforeSave: function () {
        let newMarkupLines = this.lineItems.filter(function (lineItem) {
            return lineItem.markup && lineItem.isNew();
        });
        this.lineItems.remove(newMarkupLines);

        this.set({
            lineItems: this.lineItems.toJSON(),
            attachments: this.attachments.toJSON(),
            w9Attachments: this.w9Attachments.toJSON(),
            coiAttachments: this.coiAttachments.toJSON(),
            lienWaiverAttachments: this.lienWaiverAttachments.toJSON(),
            signedDocumentAttachments: this.signedDocumentAttachments.toJSON(),
            affidavitAttachments: this.affidavitAttachments.toJSON(),
            executedDocumentAttachments: this.executedDocumentAttachments.toJSON(),
            customFieldAttachments: this.customFieldAttachments.toJSON(),
            markupItems: this.markupItems.toJSON()
        });
    },
    submit: function (callback) {
        this.beforeSave();
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/submit',
            isAPIv2: true,
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            this.set(this.parse(response));
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (response) {
            if (typeof callback === 'function') {
                callback(false);
            }
        }, this));
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            case PJQ.constants.integrations.providers.QBO.name:
                return 'https://app.sandbox.qbo.intuit.com/app/purchaseorder?txnId=' + externalId;
            default:
                return '';
        }
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    getSubTotal: function () {
        return this.get('amount') + this.get('markupAmount');
    },
    getGrandTotal: function () {
        return this.getSubTotal() + this.get('taxAmount');
    }
});

PJQ.models.commitments.HistoryItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    actionNames: {
        'status': 'Status Changed',
        'submit': 'Submitted',
        'signed': 'Signed & Submitted',
        'email': 'Email Sent'
    },
    getActionName: function () {
        return this.actionNames[this.get('action')] ?? this.get('action');
    },
    getDescription: function () {
        switch (this.get('action')) {
            case 'status':
                let fromStatus = this.get('data').from,
                    toStatus = this.get('data').to;
                if (fromStatus == null || toStatus == null) {
                    return '';
                }

                return '' + PJQ.constants.commitments.commitmentStatusNames[fromStatus] + '<i class="fal fa-arrow-right ml-1 mr-1 fs-14"></i>' + PJQ.constants.commitments.commitmentStatusNames[toStatus];
            case 'email':
                let to = this.get('data').to;
                if (_.size(to) === 0) {
                    return '';
                }

                return 'To: ' + to.join(', ');
            default:
                return '';
        }
    }
});

PJQ.models.commitments.CommitmentLineItem = PJQ.models.budget.BaseLineItem.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.commitments.CommitmentAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.commitments.CustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.commitments.CustomFieldChoice = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'customfields',
                value: this.get('customFieldId')
            },
            {
                endpoint: 'choices',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.commitments.Settings = PJQ.models.budget.Settings.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    parse: function (model) {
        if (model == null) {
            return model;
        }

        if (_.size(model.outForBidStatusName) > 0) {
            PJQ.constants.commitments.commitmentStatusNames[PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_OUT_FOR_BID] = model.outForBidStatusName;
        }

        return model;
    },
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'commitments'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'settings'
            }
        ]);
    }
});

PJQ.models.commitments.Term = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'termsId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'terms',
                value: this.id
            }
        ]);
    }
});

PJQ.models.commitments.FieldSetting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: this.id ? this.id : 'commitments'
            }
        ]);
    }
});

PJQ.models.commitments.CommitmentUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.collections.commitments.Commitments = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.Commitment,
    endpoint: function () {
        let params = [];
        if (this.options.withLineItems) {
            params.push({
                parameter: 'withLineItems',
                value: this.options.withLineItems
            });
        }
        if (this.options.costCodeId && this.options.costTypeId) {
            params.push({
                parameter: 'costCodeId',
                value: this.options.costCodeId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'commitments'
            }
        ], params);
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        _.each(PJQ.constants.commitments.commitmentStatusBuckets, function (bucket) {
            let total = 0;
            _.each(this.models, function (commitment) {
                if (bucket.statuses.indexOf(commitment.get('statusId')) !== -1) {
                    total += commitment.get('totalAmount');
                }
            });
            result[bucket.name] = total;
        }, this);
        return result;
    }
});

PJQ.collections.commitments.History = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.HistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments',
                value: this.options.commitmentId
            },
            {
                endpoint: 'history'
            }
        ]);
    }
});

PJQ.collections.commitments.CommitmentLineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.CommitmentLineItem,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments',
                value: this.options.commitmentId
            },
            {
                endpoint: 'lineitems'
            }
        ], params);
    }
});

PJQ.collections.commitments.CommitmentAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.CommitmentAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments',
                value: this.options.commitmentId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.commitments.CustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.CustomField,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'commitments'
                },
                {
                    endpoint: 'customfields'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'customfields'
            }
        ]);
    }
});

PJQ.collections.commitments.CustomFieldChoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.CustomFieldChoice
});

PJQ.collections.commitments.Terms = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.Term,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'commitments'
                },
                {
                    endpoint: 'terms'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'terms'
            }
        ]);
    }
});

PJQ.collections.commitments.FieldSettings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.FieldSetting,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'settings'
                },
                {
                    endpoint: 'fields',
                    value: 'commitments'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: 'commitments'
            }
        ]);
    }
});

PJQ.views.commitments.CommitmentSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'modal-commitment-settings'),
        minWidth: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click .btn-edit-company-default': 'editCompanySettings',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        this.userSettings = this.options.commitmentsView.userSettings;
    },
    beforeRender: function () {
        // copy userSettings for our UI; we only update global userSettings object on save.
        this.options.userSettings = [];

        this.options.defaultTypeFilter = this.userSettings.get('defaultTypeFilter');
        this.options.defaultStatusFilter = this.userSettings.get('defaultStatusFilter');
        _.each(this.userSettings.attributes.viewSettings, _.bind(function (setting) {
            let columns = this.options.commitmentsView.dataTable.getColumns(true),
                selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.userSettings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });
        }, this));
    },
    renderData: function () {
        return {
            userSettings: this.userSettings
        }
    },
    afterRender: function () {
        let defaultFilter = {};
        defaultFilter[PJQ.constants.commitments.filterType.TYPE_FILTER] = this.userSettings.get('defaultCommitmentTypeFilter');
        defaultFilter[PJQ.constants.commitments.filterType.TYPE_FILTER] = _.map(defaultFilter[PJQ.constants.commitments.filterType.TYPE_FILTER], function (type) {
            return type * -1;
        });
        defaultFilter[PJQ.constants.commitments.filterType.STATUS_FILTER] = this.userSettings.get('defaultCommitmentStatusFilter');

        this.defaultFilterSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-filter-default'),
            isIntChoices: true,
            isMultiple: true,
            isGrouped: true,
            defaultValue: defaultFilter,
            onChange: _.bind(function () {
                this.options.defaultTypeFilter = this.defaultFilterSelectPicker.getValue()[PJQ.constants.commitments.filterType.TYPE_FILTER];
                this.options.defaultTypeFilter = _.map(this.options.defaultTypeFilter, function (type) {
                    return type * -1;
                });
                this.options.defaultStatusFilter = this.defaultFilterSelectPicker.getValue()[PJQ.constants.commitments.filterType.STATUS_FILTER];
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)
        });

        this.selectView(PJQ.constants.commitments.view.COMMITMENTS);
    },
    editCompanySettings: function () {
        this.userSettings = new PJQ.models.commitments.CommitmentUserSettings(null, {
            forCompany: true
        });
        this.userSettings.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.userSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        if (view.indexOf('-') === -1) {
            this.rowsPerPage.setValue(this.currentView.rowsPerPage);
            this.$('div.rows-per-page').show();
        }
        else
            this.$('div.rows-per-page').hide();

        if (this.dataTable) {
            this.dataTable.undelegateEvents();
            $(this.dataTable.el).empty();
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('div.select-columns-datatable'),
            data: this.currentView.columns,
            isHideSearch: true,
            pageLength: 6,
            order: [],
            columns: [
                {"data": "title", "title": "Column", "orderable": false},
                {
                    "data": "visible",
                    "title": "Show",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data) {
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '10%'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });

    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {

        let fnOnSave = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();
            this.removeModal();
        }, this);

        this.userSettings.set('defaultCommitmentTypeFilter', this.options.defaultTypeFilter);
        this.userSettings.set('defaultCommitmentStatusFilter', this.options.defaultStatusFilter);

        _.each(this.options.userSettings, _.bind(function (settingTemp) {
            _.each(this.userSettings.get('viewSettings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        }
                        else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        this.userSettings.save(null, {
            success: _.bind(function () {
                fnOnSave();
            }, this)
        });
    },
});